(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["@readcube/rcp-citation-export"] = {}));
})(this, (function (exports) { 'use strict';

  function formatAuthor(author) {
      var _a, _b;
      const parts = (_a = author === null || author === void 0 ? void 0 : author.split(" ")) === null || _a === void 0 ? void 0 : _a.filter(s => s);
      if (!parts || !parts.length)
          return "";
      if (parts.length === 1)
          return parts[0];
      const lastName = (_b = parts
          .pop()) === null || _b === void 0 ? void 0 : _b.trim();
      const names = parts
          .join(" ")
          .trim();
      const formattedAuthor = lastName + ", " + names;
      return formattedAuthor;
  }
  const getNewLine = (newLine) => newLine || "\r\n";
  const getYearMonth = (date) => {
      if (!/^\d+-\d+-\d+/.test(date))
          return { year: null, month: null };
      const yearMatch = /^\d+/.exec(date);
      const year = yearMatch && yearMatch[0];
      const monthMatch = /^\d+-(\d+)/.exec(date);
      const month = monthMatch && monthMatch[1];
      return { year, month };
  };
  const removeEmpty$1 = (out) => Object.entries(out)
      .filter(([key, value]) => value !== "" && value !== null && typeof value !== "undefined")
      .reduce((acc, entry) => {
      const [key, value] = entry;
      acc[key] = value;
      return acc;
  }, {});
  const onFile = (item, cb) => {
      const hasFiles = item.files && item.files.length;
      if (!hasFiles)
          return;
      const primaryWithPath = item.files
          .find((f) => f.type === "article" && f.localPath);
      if (!primaryWithPath)
          return;
      const localhostPrefix = process.platform === "win32"
          ? "file://localhost/"
          : "file://localhost";
      const path = localhostPrefix + primaryWithPath.localPath.replace(/ /g, "%20");
      cb(path);
  };

  const authors = (item) => item.article && item.article.authors
      ? item.article.authors.map((author) => ["AU", formatAuthor(author)])
      : [];

  var field_defs = {
  	type: {
  		input: {
  			label: null,
  			type: "select",
  			required: true,
  			array: false,
  			pattern: null,
  			disabled: false,
  			"default": "article",
  			options: {
  				groups: [
  					{
  						id: "primary",
  						text: "Primary"
  					}
  				],
  				values: [
  					{
  						id: "radio_broadcast",
  						text: "Radio Broadcast",
  						group: "primary"
  					},
  					{
  						id: "dictionary_entry",
  						text: "Dictionary Entry",
  						group: "primary"
  					},
  					{
  						id: "encyclopedia_article",
  						text: "Encyclopedia Article",
  						group: "primary"
  					},
  					{
  						id: "manuscript",
  						text: "Manuscript",
  						group: "primary"
  					},
  					{
  						id: "email",
  						text: "E-Mail",
  						group: "primary"
  					},
  					{
  						id: "instant_message",
  						text: "Instant Message",
  						group: "primary"
  					},
  					{
  						id: "letter",
  						text: "Letter",
  						group: "primary"
  					},
  					{
  						id: "forum_post",
  						text: "Forum Post",
  						group: "primary"
  					},
  					{
  						id: "blog_post",
  						text: "Blog Post",
  						group: "primary"
  					},
  					{
  						id: "artwork",
  						text: "Artwork",
  						group: "primary"
  					},
  					{
  						id: "audio_recording",
  						text: "Audio Recording",
  						group: "primary"
  					},
  					{
  						id: "bill",
  						text: "Bill",
  						group: "primary"
  					},
  					{
  						id: "book",
  						text: "Book",
  						group: "primary"
  					},
  					{
  						id: "book_section",
  						text: "Book Section",
  						group: "primary"
  					},
  					{
  						id: "case",
  						text: "Case",
  						group: "primary"
  					},
  					{
  						id: "computer_program",
  						text: "Computer Program",
  						group: "primary"
  					},
  					{
  						id: "conference_paper",
  						text: "Conference Paper",
  						group: "primary"
  					},
  					{
  						id: "document",
  						text: "Document",
  						group: "primary"
  					},
  					{
  						id: "film",
  						text: "Film",
  						group: "primary"
  					},
  					{
  						id: "hearing",
  						text: "Hearing",
  						group: "primary"
  					},
  					{
  						id: "interview",
  						text: "Interview",
  						group: "primary"
  					},
  					{
  						id: "article",
  						text: "Journal Article",
  						group: "primary"
  					},
  					{
  						id: "magazine",
  						text: "Magazine",
  						group: "primary"
  					},
  					{
  						id: "map",
  						text: "Map",
  						group: "primary"
  					},
  					{
  						id: "newspaper_article",
  						text: "Newspaper Article",
  						group: "primary"
  					},
  					{
  						id: "patent",
  						text: "Patent",
  						group: "primary"
  					},
  					{
  						id: "podcast",
  						text: "Podcast",
  						group: "primary"
  					},
  					{
  						id: "presentation",
  						text: "Presentation",
  						group: "primary"
  					},
  					{
  						id: "report",
  						text: "Report",
  						group: "primary"
  					},
  					{
  						id: "statute",
  						text: "Statute",
  						group: "primary"
  					},
  					{
  						id: "thesis",
  						text: "Thesis",
  						group: "primary"
  					},
  					{
  						id: "tv_broadcast",
  						text: "TV Broadcast",
  						group: "primary"
  					},
  					{
  						id: "video_recording",
  						text: "Video Recording",
  						group: "primary"
  					},
  					{
  						id: "webpage",
  						text: "Web Page",
  						group: "primary"
  					},
  					{
  						id: "abstract",
  						text: "Abstract",
  						group: "primary"
  					},
  					{
  						id: "poster",
  						text: "Poster",
  						group: "primary"
  					}
  				]
  			}
  		},
  		readcube: "item_type",
  		csl: "type"
  	},
  	citekey: {
  		readcube: "user_data.citekey",
  		input: {
  			label: "Citekey",
  			type: "text",
  			required: false,
  			array: false,
  			pattern: null,
  			disabled: false
  		}
  	},
  	radio_broadcast_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	radio_broadcast_director: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Director",
  		endnotePath: "contributors.authors.author",
  		papers: "directors",
  		input: {
  			required: false,
  			label: "Director",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	radio_broadcast_contributor: {
  		ris: "AU",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	radio_broadcast_cast_member: {
  		ris: "C1",
  		endnotePath: "contributors.subsidiary-authors.author",
  		input: {
  			required: false,
  			label: "Cast Member",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "cast_member"
  	},
  	radio_broadcast_producer: {
  		ris: "A3",
  		papers: "producers",
  		input: {
  			required: false,
  			label: "Producer",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "producer"
  	},
  	radio_broadcast_scriptwriter: {
  		input: {
  			required: false,
  			label: "Scriptwriter",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "scriptwriter"
  	},
  	radio_broadcast_guest: {
  		papers: "guests",
  		input: {
  			required: false,
  			label: "Guest",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "guest"
  	},
  	radio_broadcast_publication_title: {
  		bib: "journal",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Publication Title",
  		endnotePath: "periodical.full-title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	radio_broadcast_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	radio_broadcast_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	radio_broadcast_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	radio_broadcast_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	radio_broadcast_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	radio_broadcast_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	radio_broadcast_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	radio_broadcast_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	radio_broadcast_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	radio_broadcast_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	radio_broadcast_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	radio_broadcast_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	radio_broadcast_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	radio_broadcast_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	radio_broadcast_number: {
  		ris: "M1",
  		csl: "number",
  		csv: "Number",
  		endnotePath: "misc1",
  		papers: "number",
  		input: {
  			required: false,
  			label: "Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number"
  	},
  	radio_broadcast_running_time: {
  		csl: "dimensions",
  		csv: "Running Time",
  		papers: "time",
  		input: {
  			required: false,
  			label: "Running Time",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "dimensions"
  	},
  	radio_broadcast_medium: {
  		ris: "C5",
  		csl: "medium",
  		csv: "Medium",
  		endnotePath: "custom5",
  		papers: "material",
  		input: {
  			required: false,
  			label: "Medium",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "medium"
  	},
  	dictionary_entry_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	dictionary_entry_editor: {
  		bib: "editor",
  		ris: "A2",
  		csl: "editor",
  		csv: "Editor",
  		papers: "editors",
  		input: {
  			required: false,
  			label: "Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "editor"
  	},
  	dictionary_entry_series_editor: {
  		bib: "editorb",
  		ris: "A3",
  		csl: "collection-editor",
  		csv: "Series Editor",
  		input: {
  			required: false,
  			label: "Series Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "series_editor"
  	},
  	dictionary_entry_translator: {
  		bib: "translator",
  		ris: "A4",
  		csl: "translator",
  		csv: "Translator",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "translators",
  		input: {
  			required: false,
  			label: "Translator",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "translator"
  	},
  	dictionary_entry_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		endnotePath: "contributors.authors.author",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	dictionary_entry_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	dictionary_entry_publication_title: {
  		bib: "journal",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Publication Title",
  		endnotePath: "periodical.full-title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	dictionary_entry_isbn: {
  		bib: "isbn",
  		ris: "SN",
  		csl: "ISBN",
  		csv: "ISBN",
  		endnotePath: "isbn",
  		papers: "isbn",
  		input: {
  			required: false,
  			label: "ISBN",
  			type: "text",
  			array: false,
  			pattern: "(ISBN[-]*(1[03])*[ ]*(: ){0,1})*(([0-9Xx][- ]*){13}|([0-9Xx][- ]*){10})",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.isbn"
  	},
  	dictionary_entry_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	dictionary_entry_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	dictionary_entry_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	dictionary_entry_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	dictionary_entry_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	dictionary_entry_number_of_volumes: {
  		ris: "NV",
  		csl: "number-of-volumes",
  		csv: "Number Of Volumes",
  		endnotePath: "num-vols",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Number Of Volumes",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number_of_volumes"
  	},
  	dictionary_entry_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	dictionary_entry_series: {
  		bib: "series",
  		csl: "collection-title",
  		csv: "Series",
  		input: {
  			required: false,
  			label: "Series",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	dictionary_entry_series_number: {
  		bib: "number",
  		csl: "collection-number",
  		csv: "Series Number",
  		input: {
  			required: false,
  			label: "Series Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "collection_number"
  	},
  	dictionary_entry_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	dictionary_entry_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	dictionary_entry_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	dictionary_entry_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	dictionary_entry_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	dictionary_entry_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	dictionary_entry_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	dictionary_entry_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	dictionary_entry_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	dictionary_entry_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	dictionary_entry_edition: {
  		bib: "edition",
  		ris: "ET",
  		csl: "edition",
  		csv: "Edition",
  		endnotePath: "edition",
  		papers: "edition",
  		input: {
  			required: false,
  			label: "Edition",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "edition"
  	},
  	encyclopedia_article_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	encyclopedia_article_editor: {
  		bib: "editor",
  		ris: "A2",
  		csl: "editor",
  		csv: "Editor",
  		papers: "editors",
  		input: {
  			required: false,
  			label: "Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "editor"
  	},
  	encyclopedia_article_series_editor: {
  		bib: "editorb",
  		ris: "A3",
  		csl: "collection-editor",
  		csv: "Series Editor",
  		input: {
  			required: false,
  			label: "Series Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "series_editor"
  	},
  	encyclopedia_article_translator: {
  		bib: "translator",
  		ris: "A4",
  		csl: "translator",
  		csv: "Translator",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "translators",
  		input: {
  			required: false,
  			label: "Translator",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "translator"
  	},
  	encyclopedia_article_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	encyclopedia_article_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	encyclopedia_article_publication_title: {
  		bib: "journal",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Publication Title",
  		endnotePath: "periodical.full-title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	encyclopedia_article_isbn: {
  		bib: "isbn",
  		ris: "SN",
  		csl: "ISBN",
  		csv: "ISBN",
  		endnotePath: "isbn",
  		papers: "isbn",
  		input: {
  			required: false,
  			label: "ISBN",
  			type: "text",
  			array: false,
  			pattern: "(ISBN[-]*(1[03])*[ ]*(: ){0,1})*(([0-9Xx][- ]*){13}|([0-9Xx][- ]*){10})",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.isbn"
  	},
  	encyclopedia_article_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	encyclopedia_article_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	encyclopedia_article_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	encyclopedia_article_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	encyclopedia_article_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	encyclopedia_article_number_of_volumes: {
  		ris: "NV",
  		csl: "number-of-volumes",
  		csv: "Number Of Volumes",
  		endnotePath: "num-vols",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Number Of Volumes",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number_of_volumes"
  	},
  	encyclopedia_article_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	encyclopedia_article_series: {
  		bib: "series",
  		csl: "collection-title",
  		csv: "Series",
  		input: {
  			required: false,
  			label: "Series",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	encyclopedia_article_series_number: {
  		bib: "number",
  		csl: "collection-number",
  		csv: "Series Number",
  		input: {
  			required: false,
  			label: "Series Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "collection_number"
  	},
  	encyclopedia_article_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	encyclopedia_article_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	encyclopedia_article_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	encyclopedia_article_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	encyclopedia_article_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	encyclopedia_article_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	encyclopedia_article_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	encyclopedia_article_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	encyclopedia_article_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	encyclopedia_article_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	encyclopedia_article_edition: {
  		bib: "edition",
  		ris: "ET",
  		csl: "edition",
  		csv: "Edition",
  		endnotePath: "edition",
  		papers: "edition",
  		input: {
  			required: false,
  			label: "Edition",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "edition"
  	},
  	manuscript_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	manuscript_translator: {
  		bib: "translator",
  		ris: "A4",
  		csl: "translator",
  		csv: "Translator",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "translators",
  		input: {
  			required: false,
  			label: "Translator",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "translator"
  	},
  	manuscript_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	manuscript_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	manuscript_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	manuscript_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	manuscript_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	manuscript_num_pages: {
  		ris: "SP",
  		csl: "number-of-pages",
  		csv: "Num Pages",
  		endnotePath: "pages",
  		input: {
  			required: false,
  			label: "Num Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number_of_pages"
  	},
  	manuscript_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	manuscript_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	manuscript_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	manuscript_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	manuscript_type: {
  		bib: "type",
  		ris: "M3",
  		csl: "genre",
  		csv: "Type",
  		endnotePath: "misc2",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	manuscript_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	manuscript_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	manuscript_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	manuscript_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	manuscript_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	manuscript_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	email_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	email_contributor: {
  		csl: "author",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	email_recipient: {
  		ris: "A2",
  		csl: "author",
  		endnotePath: "contributors.secondary-authors.author",
  		input: {
  			required: false,
  			label: "Recipient",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "recipient"
  	},
  	email_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	email_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	email_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	email_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	email_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	email_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	email_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	email_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	email_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	email_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	instant_message_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	instant_message_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	instant_message_recipient: {
  		csl: "recipient",
  		csv: "Recipient",
  		endnotePath: "contributors.secondary-authors.author",
  		input: {
  			required: false,
  			label: "Recipient",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "recipient"
  	},
  	instant_message_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	instant_message_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	instant_message_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	instant_message_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	instant_message_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	instant_message_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	instant_message_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	instant_message_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	instant_message_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	letter_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	letter_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	letter_recipient: {
  		ris: "A2",
  		csl: "recipient",
  		csv: "Recipient",
  		endnotePath: "contributors.secondary-authors.author",
  		input: {
  			required: false,
  			label: "Recipient",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "recipient"
  	},
  	letter_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	letter_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	letter_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	letter_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	letter_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	letter_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	letter_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	letter_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	letter_type: {
  		bib: "type",
  		ris: "M3",
  		csl: "genre",
  		csv: "Type",
  		endnotePath: "misc2",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	letter_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	letter_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	letter_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	letter_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	letter_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	letter_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	forum_post_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	forum_post_contributor: {
  		bib: "editora",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	forum_post_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	forum_post_publication_title: {
  		bib: "journal",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Publication Title",
  		endnotePath: "periodical.full-title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	forum_post_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	forum_post_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	forum_post_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	forum_post_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	forum_post_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	forum_post_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	forum_post_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	forum_post_type: {
  		bib: "type",
  		ris: "M3",
  		csl: "genre",
  		csv: "Type",
  		endnotePath: "misc2",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	forum_post_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	forum_post_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	blog_post_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	blog_post_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	blog_post_commenter: {
  		bib: "commentator",
  		ris: "C2",
  		csv: "Commenter",
  		papers: "reviwers",
  		input: {
  			required: false,
  			label: "Commenter",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "commenter"
  	},
  	blog_post_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	blog_post_publication_title: {
  		bib: "journal",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Publication Title",
  		endnotePath: "periodical.full-title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	blog_post_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	blog_post_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	blog_post_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	blog_post_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	blog_post_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	blog_post_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	blog_post_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	blog_post_type: {
  		bib: "type",
  		ris: "M3",
  		csl: "genre",
  		csv: "Type",
  		endnotePath: "misc2",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	blog_post_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	blog_post_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	artwork_artist: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Artist",
  		endnotePath: "contributors.authors.author",
  		papers: "designers",
  		input: {
  			required: false,
  			label: "Artist",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	artwork_contributor: {
  		bib: "editora",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	artwork_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	artwork_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	artwork_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	artwork_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	artwork_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	artwork_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	artwork_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	artwork_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	artwork_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	artwork_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	artwork_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	artwork_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	artwork_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	artwork_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	artwork_medium: {
  		ris: "M3",
  		csl: "medium",
  		csv: "Medium",
  		endnotePath: "misc2",
  		papers: "material",
  		input: {
  			required: false,
  			label: "Medium",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "medium"
  	},
  	artwork_artwork_size: {
  		ris: "C3",
  		csl: "dimensions",
  		csv: "Artwork Size",
  		endnotePath: "custom3",
  		input: {
  			required: false,
  			label: "Artwork Size",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "dimensions"
  	},
  	audio_recording_performer: {
  		bib: "author",
  		ris: "A2",
  		csl: "author",
  		csv: "Performer",
  		endnotePath: "contributors.secondary-authors.author",
  		papers: "performers",
  		input: {
  			required: false,
  			label: "Performer",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	audio_recording_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	audio_recording_composer: {
  		ris: "AU",
  		csv: "Composer",
  		papers: "composed",
  		input: {
  			required: false,
  			label: "Composer",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "composer"
  	},
  	audio_recording_words_by: {
  		ris: "C4",
  		csv: "Words By",
  		input: {
  			required: false,
  			label: "Words By",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "words_by"
  	},
  	audio_recording_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	audio_recording_isbn: {
  		bib: "isbn",
  		ris: "SN",
  		csl: "ISBN",
  		csv: "ISBN",
  		endnotePath: "isbn",
  		papers: "isbn",
  		input: {
  			required: false,
  			label: "ISBN",
  			type: "text",
  			array: false,
  			pattern: "(ISBN[-]*(1[03])*[ ]*(: ){0,1})*(([0-9Xx][- ]*){13}|([0-9Xx][- ]*){10})",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.isbn"
  	},
  	audio_recording_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	audio_recording_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	audio_recording_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	audio_recording_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	audio_recording_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	audio_recording_number_of_volumes: {
  		ris: "NV",
  		csl: "number-of-volumes",
  		csv: "Number Of Volumes",
  		endnotePath: "num-vols",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Number Of Volumes",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number_of_volumes"
  	},
  	audio_recording_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	audio_recording_series_title: {
  		ris: "T3",
  		csl: "collection-title",
  		csv: "Series Title",
  		endnotePath: "titles.tertiary-title",
  		input: {
  			required: false,
  			label: "Series Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	audio_recording_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	audio_recording_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	audio_recording_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	audio_recording_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	audio_recording_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	audio_recording_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	audio_recording_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	audio_recording_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	audio_recording_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	audio_recording_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	audio_recording_running_time: {
  		csl: "dimensions",
  		csv: "Running Time",
  		papers: "time",
  		input: {
  			required: false,
  			label: "Running Time",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "dimensions"
  	},
  	audio_recording_medium: {
  		ris: "C5",
  		csl: "medium",
  		csv: "Medium",
  		endnotePath: "custom5",
  		papers: "material",
  		input: {
  			required: false,
  			label: "Medium",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "medium"
  	},
  	bill_sponsor: {
  		bib: "author",
  		ris: "A2",
  		csl: "author",
  		csv: "Sponsor",
  		endnotePath: "contributors.secondary-authors.author",
  		papers: "co-sponsors",
  		input: {
  			required: false,
  			label: "Sponsor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	bill_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	bill_cosponsor: {
  		ris: "A3",
  		csv: "Cosponsor",
  		endnotePath: "contributors.tertiary-authors.author",
  		papers: "co-sponsors",
  		input: {
  			required: false,
  			label: "Cosponsor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "cosponsor"
  	},
  	bill_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	bill_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	bill_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	bill_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	bill_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	bill_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	bill_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	bill_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	bill_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	bill_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	bill_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	bill_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	bill_number: {
  		ris: "M1",
  		csl: "number",
  		csv: "Number",
  		endnotePath: "misc1",
  		papers: "number",
  		input: {
  			required: false,
  			label: "Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number"
  	},
  	bill_code: {
  		ris: "T2",
  		csl: "container-title",
  		csv: "Code",
  		endnotePath: "titles.secondary-title",
  		papers: "code",
  		input: {
  			required: false,
  			label: "Code",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	bill_section: {
  		bib: "chapter",
  		ris: "SE",
  		csl: "section",
  		csv: "Section",
  		endnotePath: "section",
  		papers: "section",
  		input: {
  			required: false,
  			label: "Section",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "section"
  	},
  	bill_session: {
  		ris: "ET",
  		csl: "chapter-number",
  		csv: "Session",
  		endnotePath: "edition",
  		papers: "session",
  		input: {
  			required: false,
  			label: "Session",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "chapter_number"
  	},
  	bill_history: {
  		ris: "OP",
  		csl: "references",
  		csv: "History",
  		endnotePath: "orig-pub",
  		input: {
  			required: false,
  			label: "History",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "references"
  	},
  	bill_legislative_body: {
  		ris: "T3",
  		csl: "authority",
  		csv: "Legislative Body",
  		endnotePath: "titles.tertiary-title",
  		input: {
  			required: false,
  			label: "Legislative Body",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "authority"
  	},
  	book_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	book_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	book_editor: {
  		bib: "editor",
  		ris: "A3",
  		csl: "editor",
  		papers: "editors",
  		input: {
  			required: false,
  			label: "Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "editor"
  	},
  	book_series_editor: {
  		bib: "editorb",
  		ris: "A2",
  		csl: "collection-editor",
  		input: {
  			required: false,
  			label: "Series Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "series_editor"
  	},
  	book_translator: {
  		bib: "translator",
  		ris: "A4",
  		csl: "translator",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "translators",
  		input: {
  			required: false,
  			label: "Translator",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "translator"
  	},
  	book_contributor: {
  		bib: "editora",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	book_isbn: {
  		bib: "isbn",
  		ris: "SN",
  		csl: "ISBN",
  		csv: "ISBN",
  		endnotePath: "isbn",
  		papers: "isbn",
  		input: {
  			required: false,
  			label: "ISBN",
  			type: "text",
  			array: false,
  			pattern: "(ISBN[-]*(1[03])*[ ]*(: ){0,1})*(([0-9Xx][- ]*){13}|([0-9Xx][- ]*){10})",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.isbn"
  	},
  	book_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	book_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	book_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	book_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	book_num_pages: {
  		ris: "SP",
  		csl: "number-of-pages",
  		csv: "Num Pages",
  		endnotePath: "pages",
  		input: {
  			required: false,
  			label: "Num Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number_of_pages"
  	},
  	book_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	book_number_of_volumes: {
  		ris: "NV",
  		csl: "number-of-volumes",
  		csv: "Number Of Volumes",
  		endnotePath: "num-vols",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Number Of Volumes",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number_of_volumes"
  	},
  	book_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	book_series: {
  		bib: "series",
  		ris: "T2",
  		csl: "collection-title",
  		csv: "Series",
  		endnotePath: "titles.secondary-title",
  		input: {
  			required: false,
  			label: "Series",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	book_series_number: {
  		bib: "number",
  		ris: "M1",
  		csl: "collection-number",
  		csv: "Series Number",
  		endnotePath: "misc1",
  		input: {
  			required: false,
  			label: "Series Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "collection_number"
  	},
  	book_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	book_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	book_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	book_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	book_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	book_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	book_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	book_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	book_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	book_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	book_edition: {
  		bib: "edition",
  		ris: "ET",
  		csl: "edition",
  		csv: "Edition",
  		endnotePath: "edition",
  		papers: "edition",
  		input: {
  			required: false,
  			label: "Edition",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "edition"
  	},
  	book_doi: {
  		bib: "doi",
  		ris: "DO",
  		csl: "DOI",
  		csv: "DOI",
  		endnotePath: "electronic-resource-num",
  		papers: "doi",
  		input: {
  			required: false,
  			label: "DOI",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "ext_ids.doi"
  	},
  	book_section_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	book_section_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	book_section_editor: {
  		bib: "editor",
  		ris: "A2",
  		csl: "editor",
  		papers: "editors",
  		input: {
  			required: false,
  			label: "Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "editor"
  	},
  	book_section_series_editor: {
  		bib: "editorb",
  		ris: "A3",
  		csl: "collection-editor",
  		input: {
  			required: false,
  			label: "Series Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "series_editor"
  	},
  	book_section_translator: {
  		bib: "translator",
  		ris: "A4",
  		csl: "translator",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "translators",
  		input: {
  			required: false,
  			label: "Translator",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "translator"
  	},
  	book_section_contributor: {
  		bib: "editora",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	book_section_book_author: {
  		bib: "bookauthor",
  		ris: "C2",
  		csl: "container-author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Book Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "book_author"
  	},
  	book_section_publication_title: {
  		bib: "booktitle",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Publication Title",
  		endnotePath: "periodical.full-title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	book_section_isbn: {
  		bib: "isbn",
  		ris: "SN",
  		csl: "ISBN",
  		csv: "ISBN",
  		endnotePath: "isbn",
  		papers: "isbn",
  		input: {
  			required: false,
  			label: "ISBN",
  			type: "text",
  			array: false,
  			pattern: "(ISBN[-]*(1[03])*[ ]*(: ){0,1})*(([0-9Xx][- ]*){13}|([0-9Xx][- ]*){10})",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.isbn"
  	},
  	book_section_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	book_section_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	book_section_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	book_section_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	book_section_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	book_section_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	book_section_number_of_volumes: {
  		ris: "IS",
  		csl: "number-of-volumes",
  		csv: "Number Of Volumes",
  		endnotePath: "issue",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Number Of Volumes",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number_of_volumes"
  	},
  	book_section_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	book_section_series: {
  		bib: "series",
  		ris: "T3",
  		csl: "collection-title",
  		csv: "Series",
  		endnotePath: "titles.tertiary-title",
  		input: {
  			required: false,
  			label: "Series",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	book_section_series_number: {
  		bib: "number",
  		ris: "SV",
  		csl: "collection-number",
  		csv: "Series Number",
  		endnotePath: "number",
  		input: {
  			required: false,
  			label: "Series Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "collection_number"
  	},
  	book_section_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	book_section_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	book_section_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	book_section_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	book_section_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	book_section_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	book_section_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	book_section_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	book_section_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	book_section_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	book_section_edition: {
  		bib: "edition",
  		ris: "ET",
  		csl: "edition",
  		csv: "Edition",
  		endnotePath: "edition",
  		papers: "edition",
  		input: {
  			required: false,
  			label: "Edition",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "edition"
  	},
  	book_section_doi: {
  		bib: "doi",
  		ris: "DO",
  		csl: "DOI",
  		csv: "DOI",
  		endnotePath: "electronic-resource-num",
  		papers: "doi",
  		input: {
  			required: false,
  			label: "DOI",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "ext_ids.doi"
  	},
  	case_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	case_contributor: {
  		csl: "author",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	case_counsel: {
  		ris: "A4",
  		csl: "author",
  		csv: "Counsel",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "judges",
  		input: {
  			required: false,
  			label: "Counsel",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "counsel"
  	},
  	case_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	case_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	case_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	case_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	case_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	case_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	case_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	case_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	case_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	case_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	case_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	case_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	case_number: {
  		ris: "SV",
  		csl: "number",
  		csv: "Number",
  		endnotePath: "number",
  		papers: "number",
  		input: {
  			required: false,
  			label: "Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number"
  	},
  	case_court: {
  		ris: "PB",
  		csl: "authority",
  		csv: "Court",
  		endnotePath: "publisher",
  		papers: "court",
  		input: {
  			required: false,
  			label: "Court",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "authority"
  	},
  	case_reporter: {
  		ris: "A2",
  		csl: "container-title",
  		csv: "Reporter",
  		endnotePath: "titles.secondary-title",
  		input: {
  			required: false,
  			label: "Reporter",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	case_history: {
  		ris: "OP",
  		csl: "references",
  		csv: "History",
  		endnotePath: "orig-pub",
  		input: {
  			required: false,
  			label: "History",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "references"
  	},
  	computer_program_programmer: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Programmer",
  		endnotePath: "contributors.authors.author",
  		input: {
  			required: false,
  			label: "Programmer",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	computer_program_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	computer_program_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	computer_program_isbn: {
  		bib: "isbn",
  		ris: "SN",
  		csl: "ISBN",
  		csv: "ISBN",
  		endnotePath: "isbn",
  		papers: "isbn",
  		input: {
  			required: false,
  			label: "ISBN",
  			type: "text",
  			array: false,
  			pattern: "(ISBN[-]*(1[03])*[ ]*(: ){0,1})*(([0-9Xx][- ]*){13}|([0-9Xx][- ]*){10})",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.isbn"
  	},
  	computer_program_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	computer_program_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	computer_program_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	computer_program_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	computer_program_series_title: {
  		ris: "T2",
  		csl: "collection-title",
  		csv: "Series Title",
  		endnotePath: "titles.secondary-title",
  		input: {
  			required: false,
  			label: "Series Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	computer_program_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	computer_program_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	computer_program_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	computer_program_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	computer_program_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	computer_program_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	computer_program_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	computer_program_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	computer_program_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	computer_program_programming_language: {
  		ris: "LA",
  		csl: "genre",
  		csv: "Programming Language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Programming Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	computer_program_version: {
  		ris: "ET",
  		csl: "version",
  		csv: "Version",
  		endnotePath: "edition",
  		papers: "version",
  		input: {
  			required: false,
  			label: "Version",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "version"
  	},
  	computer_program_system: {
  		ris: "M1",
  		csl: "medium",
  		csv: "System",
  		endnotePath: "misc1",
  		input: {
  			required: false,
  			label: "System",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "medium"
  	},
  	conference_paper_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	conference_paper_editor: {
  		csv: "translator",
  		papers: "editors",
  		input: {
  			required: false,
  			label: "Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "editor"
  	},
  	conference_paper_contributor: {
  		csv: "editora",
  		endnotePath: "contributors.subsidiary-authors.author",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	conference_paper_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	conference_paper_proceedings_title: {
  		bib: "booktitle",
  		ris: "C3",
  		csl: "container-title",
  		csv: "Proceedings Title",
  		endnotePath: "custom3",
  		input: {
  			required: false,
  			label: "Proceedings Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	conference_paper_type: {
  		ris: "M3",
  		csl: "work-type",
  		csv: "Work Type",
  		endnotePath: "work-type",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "work_type"
  	},
  	conference_paper_isbn: {
  		bib: "isbn",
  		ris: "SN",
  		csl: "ISBN",
  		csv: "ISBN",
  		endnotePath: "isbn",
  		papers: "isbn",
  		input: {
  			required: false,
  			label: "ISBN",
  			type: "text",
  			array: false,
  			pattern: "(ISBN[-]*(1[03])*[ ]*(: ){0,1})*(([0-9Xx][- ]*){13}|([0-9Xx][- ]*){10})",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.isbn"
  	},
  	conference_paper_doi: {
  		bib: "doi",
  		ris: "DO",
  		csl: "DOI",
  		csv: "DOI",
  		endnotePath: "electronic-resource-num",
  		papers: "doi",
  		input: {
  			required: false,
  			label: "DOI",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "ext_ids.doi"
  	},
  	conference_paper_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	conference_paper_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	conference_paper_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	conference_paper_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	conference_paper_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	conference_paper_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	conference_paper_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	conference_paper_series: {
  		bib: "series",
  		ris: "T3",
  		csl: "collection-title",
  		csv: "Series",
  		endnotePath: "titles.tertiary-title",
  		input: {
  			required: false,
  			label: "Series",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	conference_paper_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	conference_paper_place: {
  		bib: "address",
  		ris: "C1",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	conference_paper_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	conference_paper_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	conference_paper_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	conference_paper_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	conference_paper_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	conference_paper_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	conference_paper_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	conference_paper_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	conference_paper_conference_name: {
  		ris: "T2",
  		csl: "event",
  		csv: "Conference Name",
  		endnotePath: "titles.secondary-title",
  		papers: "event",
  		input: {
  			required: false,
  			label: "Conference Name",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event"
  	},
  	document_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	document_editor: {
  		bib: "editor",
  		ris: "A2",
  		csv: "Editor",
  		papers: "editors",
  		input: {
  			required: false,
  			label: "Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "editor"
  	},
  	document_translator: {
  		bib: "translator",
  		ris: "A4",
  		csv: "Translator",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "translators",
  		input: {
  			required: false,
  			label: "Translator",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "translator"
  	},
  	document_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	document_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	document_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	document_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	document_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	document_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	document_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	document_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	document_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	document_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	document_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	document_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	document_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	document_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	document_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	document_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	film_director: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Director",
  		endnotePath: "contributors.authors.author",
  		papers: "directors",
  		input: {
  			required: false,
  			label: "Director",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	film_contributor: {
  		ris: "A4",
  		csv: "Contributor",
  		endnotePath: "contributors.subsidiary-authors.author",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	film_producer: {
  		ris: "A3",
  		csv: "Producer",
  		papers: "producers",
  		input: {
  			required: false,
  			label: "Producer",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "producer"
  	},
  	film_scriptwriter: {
  		csv: "Scriptwriter",
  		input: {
  			required: false,
  			label: "Scriptwriter",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "scriptwriter"
  	},
  	film_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	film_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	film_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	film_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	film_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	film_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	film_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	film_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	film_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	film_type: {
  		bib: "type",
  		ris: "C4",
  		csl: "genre",
  		csv: "Type",
  		endnotePath: "custom4",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	film_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	film_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	film_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	film_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	film_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	film_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	film_running_time: {
  		ris: "SP",
  		csl: "dimensions",
  		csv: "Running Time",
  		endnotePath: "pages",
  		papers: "time",
  		input: {
  			required: false,
  			label: "Running Time",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "dimensions"
  	},
  	film_medium: {
  		ris: "C5",
  		csl: "medium",
  		csv: "Medium",
  		endnotePath: "custom5",
  		papers: "material",
  		input: {
  			required: false,
  			label: "Medium",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "medium"
  	},
  	hearing_contributor: {
  		bib: "author",
  		csl: "author",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	hearing_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	hearing_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	hearing_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	hearing_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	hearing_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	hearing_number_of_volumes: {
  		ris: "NV",
  		csl: "number-of-volumes",
  		csv: "Number Of Volumes",
  		endnotePath: "num-vols",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Number Of Volumes",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number_of_volumes"
  	},
  	hearing_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	hearing_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	hearing_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	hearing_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	hearing_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	hearing_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	hearing_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	hearing_number: {
  		ris: "M1",
  		csl: "number",
  		csv: "Number",
  		endnotePath: "misc1",
  		papers: "number",
  		input: {
  			required: false,
  			label: "Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number"
  	},
  	hearing_session: {
  		ris: "ET",
  		csl: "chapter-number",
  		csv: "Session",
  		endnotePath: "edition",
  		papers: "session",
  		input: {
  			required: false,
  			label: "Session",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "chapter_number"
  	},
  	hearing_committee: {
  		ris: "T2",
  		csl: "section",
  		csv: "Committee",
  		endnotePath: "titles.secondary-title",
  		papers: "committe",
  		input: {
  			required: false,
  			label: "Committee",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "section"
  	},
  	hearing_history: {
  		ris: "OP",
  		csl: "references",
  		csv: "History",
  		endnotePath: "orig-pub",
  		input: {
  			required: false,
  			label: "History",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "references"
  	},
  	hearing_legislative_body: {
  		ris: "T3",
  		csl: "authority",
  		csv: "Legislative Body",
  		endnotePath: "titles.tertiary-title",
  		input: {
  			required: false,
  			label: "Legislative Body",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "authority"
  	},
  	interview_interview_with: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Interview With",
  		endnotePath: "contributors.authors.author",
  		papers: "interviewers",
  		input: {
  			required: false,
  			label: "Interview With",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	interview_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	interview_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	interview_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	interview_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	interview_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	interview_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	interview_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	interview_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	interview_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	interview_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	interview_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	interview_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	interview_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	interview_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	interview_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	interview_medium: {
  		ris: "M3",
  		csl: "medium",
  		csv: "Medium",
  		endnotePath: "misc2",
  		papers: "material",
  		input: {
  			required: false,
  			label: "Medium",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "medium"
  	},
  	article_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	article_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	article_journal: {
  		bib: "journal, journaltitle",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Journal",
  		endnotePath: "periodical.full-title,titles.secondary-title",
  		papers: "journal",
  		input: {
  			required: false,
  			label: "Journal",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	article_issn: {
  		bib: "issn",
  		ris: "SN",
  		csl: "ISSN",
  		csv: "ISSN",
  		endnotePath: "isbn",
  		input: {
  			required: false,
  			label: "ISSN",
  			type: "text",
  			array: false,
  			pattern: "[0-9]{4}-[0-9]{3}[0-9xX]",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.issn"
  	},
  	article_doi: {
  		bib: "doi",
  		ris: "DO",
  		csl: "DOI",
  		csv: "DOI",
  		endnotePath: "electronic-resource-num",
  		papers: "doi",
  		input: {
  			required: false,
  			label: "DOI",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "ext_ids.doi"
  	},
  	article_pmid: {
  		bib: "pmid",
  		ris: "PMID,U1",
  		csl: "PMID",
  		csv: "PMID",
  		papers: "pmid",
  		input: {
  			required: false,
  			label: "PMID",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "ext_ids.pmid"
  	},
  	article_pmcid: {
  		bib: "pmcid",
  		ris: "U2",
  		csl: "PMCID",
  		csv: "PMCID",
  		papers: "pmcid",
  		input: {
  			required: false,
  			label: "PMCID",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "ext_ids.pmcid"
  	},
  	article_arxiv: {
  		bib: "eprint",
  		csl: "arXiv",
  		csv: "ArXiv",
  		input: {
  			required: false,
  			label: "ArXiv",
  			type: "text",
  			array: false,
  			pattern: "(\\d{4}.\\d{4,5}|[a-z\\-]+(\\.[A-Z]{2})?/\\d{7})(v\\d+)?",
  			disabled: false,
  			warning: false
  		},
  		readcube: "ext_ids.arxiv"
  	},
  	article_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	article_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	article_date: {
  		bib: "year, date",
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	article_journal_abbreviation: {
  		ris: "J2",
  		csl: "journalAbbreviation",
  		csv: "Journal Abbreviation",
  		endnotePath: "periodical.abbr-1",
  		input: {
  			required: false,
  			label: "Journal Abbreviation",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal_abbrev"
  	},
  	article_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	article_editor: {
  		bib: "editor",
  		ris: "A2",
  		csl: "editor",
  		csv: "Editor",
  		papers: "editors",
  		input: {
  			required: false,
  			label: "Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "editor"
  	},
  	article_translator: {
  		bib: "translator",
  		ris: "A4",
  		csl: "translator",
  		csv: "Translator",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "translators",
  		input: {
  			required: false,
  			label: "Translator",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "translator"
  	},
  	article_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	article_reviewed_author: {
  		csl: "reviewed-author",
  		csv: "Reviewed Author",
  		papers: "reviewers",
  		input: {
  			required: false,
  			label: "Reviewed Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "reviewed_author"
  	},
  	article_publication_title: {
  		bib: "journaltitle",
  		csl: "collection-title",
  		csv: "Publication Title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	article_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	article_issue: {
  		bib: "number",
  		ris: "IS",
  		csl: "issue",
  		csv: "Issue",
  		endnotePath: "issue",
  		papers: "issue",
  		input: {
  			required: false,
  			label: "Issue",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.issue"
  	},
  	article_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	article_series: {
  		bib: "series",
  		ris: "T3",
  		csv: "Series",
  		input: {
  			required: false,
  			label: "Series",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "series"
  	},
  	article_series_text: {
  		csv: "Series Text",
  		input: {
  			required: false,
  			label: "Series Text",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "series_text"
  	},
  	article_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	article_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	article_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	article_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	article_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	article_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	article_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	article_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	magazine_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	magazine_translator: {
  		bib: "translator",
  		ris: "A4",
  		csl: "translator",
  		csv: "Translator",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "translators",
  		input: {
  			required: false,
  			label: "Translator",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "translator"
  	},
  	magazine_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	magazine_reviewed_author: {
  		csl: "reviewed-author",
  		csv: "Reviewed Author",
  		papers: "reviewers",
  		input: {
  			required: false,
  			label: "Reviewed Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "reviewed_author"
  	},
  	magazine_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	magazine_publication_title: {
  		bib: "journal",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Publication Title",
  		endnotePath: "periodical.full-title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	magazine_issn: {
  		bib: "issn",
  		ris: "SN",
  		csl: "ISSN",
  		csv: "ISSN",
  		endnotePath: "isbn",
  		input: {
  			required: false,
  			label: "ISSN",
  			type: "text",
  			array: false,
  			pattern: "[0-9]{4}-[0-9]{3}[0-9xX]",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.issn"
  	},
  	magazine_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	magazine_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	magazine_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	magazine_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	magazine_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	magazine_issue: {
  		bib: "number",
  		ris: "IS",
  		csl: "issue",
  		csv: "Issue",
  		endnotePath: "issue",
  		papers: "issue",
  		input: {
  			required: false,
  			label: "Issue",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.issue"
  	},
  	magazine_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	magazine_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	magazine_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	magazine_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	magazine_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	magazine_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	magazine_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	magazine_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	magazine_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	magazine_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	map_cartographer: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Cartographer",
  		endnotePath: "contributors.authors.author",
  		input: {
  			required: false,
  			label: "Cartographer",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	map_series_editor: {
  		bib: "editorb",
  		ris: "A3",
  		csl: "collection-editor",
  		csv: "Series Editor",
  		endnotePath: "contributors.tertiary-authors.author",
  		input: {
  			required: false,
  			label: "Series Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "series_editor"
  	},
  	map_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	map_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	map_isbn: {
  		bib: "isbn",
  		ris: "SN",
  		csl: "ISBN",
  		csv: "ISBN",
  		endnotePath: "isbn",
  		papers: "isbn",
  		input: {
  			required: false,
  			label: "ISBN",
  			type: "text",
  			array: false,
  			pattern: "(ISBN[-]*(1[03])*[ ]*(: ){0,1})*(([0-9Xx][- ]*){13}|([0-9Xx][- ]*){10})",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.isbn"
  	},
  	map_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	map_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	map_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	map_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	map_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	map_series_title: {
  		ris: "T2",
  		csl: "collection-title",
  		csv: "Series Title",
  		endnotePath: "titles.secondary-title",
  		input: {
  			required: false,
  			label: "Series Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	map_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	map_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	map_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	map_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	map_type: {
  		bib: "type",
  		ris: "M3",
  		csl: "genre",
  		csv: "Type",
  		endnotePath: "misc2",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	map_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	map_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	map_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	map_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	map_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	map_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	map_edition: {
  		bib: "edition",
  		ris: "ET",
  		csl: "edition",
  		csv: "Edition",
  		endnotePath: "edition",
  		papers: "edition",
  		input: {
  			required: false,
  			label: "Edition",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "edition"
  	},
  	map_scale: {
  		ris: "C1",
  		csl: "scale",
  		csv: "Scale",
  		endnotePath: "custom1",
  		papers: "scale",
  		input: {
  			required: false,
  			label: "Scale",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "scale"
  	},
  	newspaper_article_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	newspaper_article_translator: {
  		bib: "translator",
  		ris: "A4",
  		csl: "translator",
  		csv: "Translator",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "translators",
  		input: {
  			required: false,
  			label: "Translator",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "translator"
  	},
  	newspaper_article_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	newspaper_article_reviewed_author: {
  		csl: "reviewed-author",
  		csv: "Reviewed Author",
  		papers: "reviewers",
  		input: {
  			required: false,
  			label: "Reviewed Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "reviewed_author"
  	},
  	newspaper_article_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	newspaper_article_publication_title: {
  		bib: "journal",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Publication Title",
  		endnotePath: "periodical.full-title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	newspaper_article_issn: {
  		bib: "issn",
  		ris: "SN",
  		csl: "ISSN",
  		csv: "ISSN",
  		endnotePath: "isbn",
  		input: {
  			required: false,
  			label: "ISSN",
  			type: "text",
  			array: false,
  			pattern: "[0-9]{4}-[0-9]{3}[0-9xX]",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.issn"
  	},
  	newspaper_article_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	newspaper_article_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	newspaper_article_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	newspaper_article_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	newspaper_article_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	newspaper_article_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	newspaper_article_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	newspaper_article_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	newspaper_article_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	newspaper_article_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	newspaper_article_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	newspaper_article_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	newspaper_article_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	newspaper_article_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	newspaper_article_edition: {
  		bib: "edition",
  		ris: "ET",
  		csl: "edition",
  		csv: "Edition",
  		endnotePath: "edition",
  		papers: "edition",
  		input: {
  			required: false,
  			label: "Edition",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "edition"
  	},
  	newspaper_article_section: {
  		bib: "chapter",
  		ris: "SE",
  		csl: "section",
  		csv: "Section",
  		endnotePath: "section",
  		papers: "section",
  		input: {
  			required: false,
  			label: "Section",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "section"
  	},
  	patent_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	patent_inventor: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Inventor",
  		endnotePath: "contributors.authors.author",
  		input: {
  			required: false,
  			label: "Inventor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	patent_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	patent_patent_id: {
  		ris: "M1",
  		csl: "call-number",
  		csv: "Patent ID",
  		endnotePath: "misc1",
  		input: {
  			required: false,
  			label: "Patent ID",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "ext_ids.patent_id"
  	},
  	patent_application_number: {
  		csv: "Application Number",
  		input: {
  			required: false,
  			label: "Application Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "application_number"
  	},
  	patent_guest: {
  		csv: "Guest",
  		papers: "guests",
  		input: {
  			required: false,
  			label: "Guest",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "guest"
  	},
  	patent_attorney_agent: {
  		ris: "C4",
  		csv: "Attorney Agent",
  		endnotePath: "custom4",
  		papers: "attorneys",
  		input: {
  			required: false,
  			label: "Attorney Agent",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "attorney_agent"
  	},
  	patent_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	patent_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	patent_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "custom2",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	patent_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	patent_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	patent_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	patent_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	patent_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	patent_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	patent_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	patent_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	patent_number: {
  		bib: "number",
  		ris: "SN",
  		csl: "number",
  		csv: "Number",
  		endnotePath: "isbn",
  		papers: "number",
  		input: {
  			required: false,
  			label: "Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number"
  	},
  	patent_filing_date: {
  		ris: "C1",
  		csv: "Filing Date",
  		endnotePath: "custom1",
  		input: {
  			required: false,
  			label: "Filing Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "filing_date"
  	},
  	patent_publication_date: {
  		csv: "Publication Date",
  		input: {
  			required: false,
  			label: "Publication Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publication_date"
  	},
  	patent_assignee: {
  		bib: "assignee",
  		ris: "PB",
  		csv: "Assignee",
  		endnotePath: "publisher",
  		input: {
  			required: false,
  			label: "Assignee",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "assignee"
  	},
  	patent_issuing_authority: {
  		ris: "A2",
  		csl: "authority",
  		csv: "Issuing Authority",
  		input: {
  			required: false,
  			label: "Issuing Authority",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "authority"
  	},
  	patent_country: {
  		bib: "nationality",
  		ris: "C3",
  		csv: "Country",
  		endnotePath: "custom3",
  		papers: "country",
  		input: {
  			required: false,
  			label: "Country",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "country"
  	},
  	patent_references: {
  		ris: "C5",
  		csl: "references",
  		csv: "References",
  		endnotePath: "custom5",
  		papers: "reference",
  		input: {
  			required: false,
  			label: "References",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "references"
  	},
  	patent_legal_status: {
  		ris: "C6",
  		csl: "status",
  		csv: "Legal Status",
  		endnotePath: "custom6",
  		input: {
  			required: false,
  			label: "Legal Status",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "status"
  	},
  	patent_priority_numbers: {
  		ris: "OP",
  		csl: "issue",
  		csv: "Priority Numbers",
  		endnotePath: "orig-pub",
  		input: {
  			required: false,
  			label: "Priority Numbers",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.issue"
  	},
  	podcast_podcaster: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Podcaster",
  		endnotePath: "contributors.authors.author",
  		input: {
  			required: false,
  			label: "Podcaster",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	podcast_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	podcast_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	podcast_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	podcast_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	podcast_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	podcast_series_title: {
  		csl: "collection-title",
  		csv: "Series Title",
  		input: {
  			required: false,
  			label: "Series Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	podcast_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	podcast_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	podcast_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	podcast_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	podcast_number: {
  		ris: "M1",
  		csl: "number",
  		csv: "Number",
  		endnotePath: "misc1",
  		papers: "number",
  		input: {
  			required: false,
  			label: "Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number"
  	},
  	podcast_running_time: {
  		csl: "dimensions",
  		csv: "Running Time",
  		papers: "time",
  		input: {
  			required: false,
  			label: "Running Time",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "dimensions"
  	},
  	podcast_medium: {
  		ris: "M3",
  		csl: "medium",
  		csv: "Medium",
  		endnotePath: "misc2",
  		papers: "material",
  		input: {
  			required: false,
  			label: "Medium",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "medium"
  	},
  	presentation_presenter: {
  		bib: "author",
  		ris: "A2",
  		csl: "author",
  		csv: "Presenter",
  		endnotePath: "contributors.secondary-authors.author",
  		input: {
  			required: false,
  			label: "Presenter",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	presentation_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	presentation_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	presentation_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	presentation_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	presentation_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	presentation_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	presentation_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	presentation_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	presentation_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	presentation_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	presentation_type: {
  		bib: "type",
  		ris: "M3",
  		csl: "genre",
  		csv: "Type",
  		endnotePath: "misc2",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	presentation_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	presentation_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	presentation_meeting_name: {
  		ris: "T2",
  		csl: "event",
  		csv: "Meeting Name",
  		endnotePath: "titles.secondary-title",
  		input: {
  			required: false,
  			label: "Meeting Name",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event"
  	},
  	report_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	report_series_editor: {
  		bib: "editorb",
  		ris: "A2",
  		csl: "collection-editor",
  		csv: "Series Editor",
  		input: {
  			required: false,
  			label: "Series Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "series_editor"
  	},
  	report_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	report_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	report_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	report_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	report_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	report_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	report_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	report_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	report_series_title: {
  		ris: "T2",
  		csl: "collection-title",
  		csv: "Series Title",
  		endnotePath: "titles.secondary-title",
  		input: {
  			required: false,
  			label: "Series Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	report_publisher: {
  		bib: "institution",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	report_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	report_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	report_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	report_type: {
  		bib: "type",
  		ris: "M3",
  		csl: "genre",
  		csv: "Type",
  		endnotePath: "misc2",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	report_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	report_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	report_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	report_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	report_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	report_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	report_number: {
  		bib: "number",
  		ris: "SN",
  		csl: "number",
  		csv: "Number",
  		endnotePath: "isbn",
  		papers: "number",
  		input: {
  			required: false,
  			label: "Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number"
  	},
  	statute_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	statute_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	statute_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	statute_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	statute_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	statute_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	statute_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	statute_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	statute_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	statute_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	statute_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	statute_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	statute_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	statute_number: {
  		ris: "M1",
  		csl: "number",
  		csv: "Number",
  		endnotePath: "misc1",
  		papers: "number",
  		input: {
  			required: false,
  			label: "Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number"
  	},
  	statute_code: {
  		ris: "T2",
  		csl: "container-title",
  		csv: "Code",
  		endnotePath: "titles.secondary-title",
  		papers: "code",
  		input: {
  			required: false,
  			label: "Code",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	statute_code_number: {
  		ris: "VL",
  		csl: "volume",
  		csv: "Code Number",
  		endnotePath: "volume",
  		input: {
  			required: false,
  			label: "Code Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	statute_section: {
  		bib: "chapter",
  		ris: "SE",
  		csl: "section",
  		csv: "Section",
  		endnotePath: "section",
  		papers: "section",
  		input: {
  			required: false,
  			label: "Section",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "section"
  	},
  	statute_session: {
  		ris: "ET",
  		csl: "chapter-number",
  		csv: "Session",
  		endnotePath: "edition",
  		papers: "session",
  		input: {
  			required: false,
  			label: "Session",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "chapter_number"
  	},
  	statute_history: {
  		ris: "OP",
  		csl: "references",
  		csv: "History",
  		endnotePath: "orig-pub",
  		input: {
  			required: false,
  			label: "History",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "references"
  	},
  	thesis_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	thesis_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	thesis_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	thesis_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	thesis_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	thesis_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	thesis_publisher: {
  		bib: "institution",
  		ris: "PB",
  		csl: "publisher",
  		csv: "publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	thesis_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	tv_broadcast_director: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Director",
  		endnotePath: "contributors.authors.author",
  		papers: "directors",
  		input: {
  			required: false,
  			label: "Director",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	tv_broadcast_cast_member: {
  		ris: "C1",
  		csv: "Cast Member",
  		endnotePath: "contributors.subsidiary-authors.author",
  		input: {
  			required: false,
  			label: "Cast Member",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "cast_member"
  	},
  	tv_broadcast_producer: {
  		ris: "A3",
  		csv: "Producer",
  		papers: "producers",
  		input: {
  			required: false,
  			label: "Producer",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "producer"
  	},
  	tv_broadcast_scriptwriter: {
  		csv: "Scriptwriter",
  		input: {
  			required: false,
  			label: "Scriptwriter",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "scriptwriter"
  	},
  	tv_broadcast_guest: {
  		csv: "Guest",
  		papers: "guests",
  		input: {
  			required: false,
  			label: "Guest",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "guest"
  	},
  	tv_broadcast_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	tv_broadcast_publication_title: {
  		bib: "journal",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Publication Title",
  		endnotePath: "periodical.full-title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	tv_broadcast_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	tv_broadcast_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	tv_broadcast_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	tv_broadcast_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	tv_broadcast_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	tv_broadcast_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	tv_broadcast_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	tv_broadcast_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	tv_broadcast_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	tv_broadcast_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	tv_broadcast_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	tv_broadcast_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	tv_broadcast_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	tv_broadcast_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	tv_broadcast_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	tv_broadcast_number: {
  		ris: "M1",
  		csl: "number",
  		csv: "Number",
  		endnotePath: "misc1",
  		papers: "number",
  		input: {
  			required: false,
  			label: "Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number"
  	},
  	tv_broadcast_running_time: {
  		csl: "dimensions",
  		csv: "Running Time",
  		papers: "time",
  		input: {
  			required: false,
  			label: "Running Time",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "dimensions"
  	},
  	tv_broadcast_medium: {
  		ris: "C5",
  		csl: "medium",
  		csv: "Medium",
  		endnotePath: "custom5",
  		papers: "material",
  		input: {
  			required: false,
  			label: "Medium",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "medium"
  	},
  	video_recording_director: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Director",
  		endnotePath: "contributors.authors.author",
  		papers: "directors",
  		input: {
  			required: false,
  			label: "Director",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	video_recording_contributor: {
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	video_recording_cast_member: {
  		ris: "C1",
  		csv: "Cast Member",
  		endnotePath: "contributors.subsidiary-authors.author",
  		input: {
  			required: false,
  			label: "Cast Member",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "cast_member"
  	},
  	video_recording_producer: {
  		ris: "A3",
  		csv: "Producer",
  		papers: "producers",
  		input: {
  			required: false,
  			label: "Producer",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "producer"
  	},
  	video_recording_scriptwriter: {
  		csv: "Scriptwriter",
  		input: {
  			required: false,
  			label: "Scriptwriter",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "scriptwriter"
  	},
  	video_recording_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	video_recording_isbn: {
  		bib: "isbn",
  		ris: "SN",
  		csl: "ISBN",
  		csv: "ISBN",
  		endnotePath: "isbn",
  		papers: "isbn",
  		input: {
  			required: false,
  			label: "ISBN",
  			type: "text",
  			array: false,
  			pattern: "(ISBN[-]*(1[03])*[ ]*(: ){0,1})*(([0-9Xx][- ]*){13}|([0-9Xx][- ]*){10})",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.isbn"
  	},
  	video_recording_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	video_recording_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	video_recording_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	video_recording_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	video_recording_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	video_recording_number_of_volumes: {
  		ris: "NV",
  		csl: "number-of-volumes",
  		csv: "Number Of Volumes",
  		endnotePath: "num-vols",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Number Of Volumes",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "number_of_volumes"
  	},
  	video_recording_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	video_recording_series_title: {
  		csl: "collection-title",
  		csv: "Series Title",
  		input: {
  			required: false,
  			label: "Series Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	video_recording_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	video_recording_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	video_recording_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	video_recording_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	video_recording_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	video_recording_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	video_recording_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	video_recording_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	video_recording_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	video_recording_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	video_recording_running_time: {
  		csl: "dimensions",
  		csv: "Running Time",
  		endnotePath: "custom3",
  		papers: "time",
  		input: {
  			required: false,
  			label: "Running Time",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "dimensions"
  	},
  	video_recording_medium: {
  		ris: "C5",
  		csl: "medium",
  		csv: "Medium",
  		endnotePath: "custom5",
  		papers: "material",
  		input: {
  			required: false,
  			label: "Medium",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "medium"
  	},
  	webpage_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	webpage_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	webpage_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	webpage_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	webpage_translator: {
  		bib: "translator",
  		ris: "A4",
  		csl: "translator",
  		csv: "Translator",
  		endnotePath: "contributors.subsidiary-authors.author",
  		papers: "translators",
  		input: {
  			required: false,
  			label: "Translator",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "translator"
  	},
  	webpage_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	webpage_publication_title: {
  		bib: "journal",
  		ris: "T2",
  		csl: "container-title",
  		csv: "Publication Title",
  		endnotePath: "periodical.full-title",
  		papers: "book",
  		input: {
  			required: false,
  			label: "Publication Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	webpage_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	webpage_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	webpage_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	webpage_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	webpage_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	webpage_type: {
  		bib: "type",
  		ris: "M3",
  		csl: "genre",
  		csv: "Type",
  		endnotePath: "misc2",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	webpage_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	webpage_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	abstract_author: {
  		bib: "author",
  		ris: "AU",
  		csl: "author",
  		csv: "Author",
  		endnotePath: "contributors.authors.author",
  		papers: "authors",
  		input: {
  			required: false,
  			label: "Author",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	abstract_editor: {
  		csv: "translator",
  		papers: "editors",
  		input: {
  			required: false,
  			label: "Editor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "editor"
  	},
  	abstract_contributor: {
  		csv: "editora",
  		endnotePath: "contributors.subsidiary-authors.author",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	abstract_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	abstract_proceedings_title: {
  		bib: "booktitle",
  		ris: "C3",
  		csl: "container-title",
  		csv: "Proceedings Title",
  		endnotePath: "custom3",
  		input: {
  			required: false,
  			label: "Proceedings Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "container_title"
  	},
  	abstract_type: {
  		ris: "M3",
  		csl: "work-type",
  		csv: "Work Type",
  		endnotePath: "work-type",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "work_type"
  	},
  	abstract_isbn: {
  		bib: "isbn",
  		ris: "SN",
  		csl: "ISBN",
  		csv: "ISBN",
  		endnotePath: "isbn",
  		papers: "isbn",
  		input: {
  			required: false,
  			label: "ISBN",
  			type: "text",
  			array: false,
  			pattern: "(ISBN[-]*(1[03])*[ ]*(: ){0,1})*(([0-9Xx][- ]*){13}|([0-9Xx][- ]*){10})",
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.isbn"
  	},
  	abstract_doi: {
  		bib: "doi",
  		ris: "DO",
  		csl: "DOI",
  		csv: "DOI",
  		endnotePath: "electronic-resource-num",
  		papers: "doi",
  		input: {
  			required: false,
  			label: "DOI",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "ext_ids.doi"
  	},
  	abstract_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	abstract_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	abstract_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	abstract_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	abstract_pages: {
  		bib: "pages",
  		ris: "SP",
  		csl: "page",
  		csv: "Pages",
  		endnotePath: "pages",
  		papers: "pages",
  		input: {
  			required: false,
  			label: "Pages",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.pagination"
  	},
  	abstract_volume: {
  		bib: "volume",
  		ris: "VL",
  		csl: "volume",
  		csv: "Volume",
  		endnotePath: "volume",
  		papers: "volume",
  		input: {
  			required: false,
  			label: "Volume",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.volume"
  	},
  	abstract_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	abstract_series: {
  		bib: "series",
  		ris: "T3",
  		csl: "collection-title",
  		csv: "Series",
  		endnotePath: "titles.tertiary-title",
  		input: {
  			required: false,
  			label: "Series",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.journal"
  	},
  	abstract_publisher: {
  		bib: "publisher",
  		ris: "PB",
  		csl: "publisher",
  		csv: "Publisher",
  		endnotePath: "publisher",
  		papers: "publisher",
  		input: {
  			required: false,
  			label: "Publisher",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "publisher"
  	},
  	abstract_place: {
  		bib: "address",
  		ris: "C1",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	abstract_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	abstract_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	abstract_archive: {
  		ris: "DB",
  		csl: "archive",
  		csv: "Archive",
  		papers: "archived",
  		input: {
  			required: false,
  			label: "Archive",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive"
  	},
  	abstract_archive_location: {
  		ris: "AN",
  		csl: "archive_location",
  		csv: "Archive Location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Archive Location",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "archive_location"
  	},
  	abstract_library_catalog: {
  		ris: "DP",
  		csl: "source",
  		csv: "Library Catalog",
  		endnotePath: "remote-database-name",
  		input: {
  			required: false,
  			label: "Library Catalog",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "source"
  	},
  	abstract_call_number: {
  		ris: "CN",
  		csl: "call-number",
  		csv: "Call Number",
  		endnotePath: "call-num",
  		papers: "call",
  		input: {
  			required: false,
  			label: "Call Number",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "call_number"
  	},
  	abstract_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	abstract_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	abstract_conference_name: {
  		ris: "T2",
  		csl: "event",
  		csv: "Conference Name",
  		endnotePath: "titles.secondary-title",
  		papers: "event",
  		input: {
  			required: false,
  			label: "Conference Name",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event"
  	},
  	poster_presenter: {
  		bib: "author",
  		ris: "A2",
  		csl: "author",
  		csv: "Presenter",
  		endnotePath: "contributors.secondary-authors.author",
  		input: {
  			required: false,
  			label: "Presenter",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.authors"
  	},
  	poster_contributor: {
  		bib: "editora",
  		csv: "Contributor",
  		input: {
  			required: false,
  			label: "Contributor",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "contributor"
  	},
  	poster_title: {
  		bib: "title",
  		ris: "TI",
  		csl: "title",
  		csv: "Title",
  		endnotePath: "titles.title",
  		papers: "title",
  		input: {
  			required: false,
  			label: "Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.title"
  	},
  	poster_url: {
  		bib: "url",
  		ris: "UR",
  		csl: "URL",
  		csv: "Url",
  		endnotePath: "urls.web-urls.url,urls.related-urls.url",
  		papers: "url",
  		input: {
  			required: false,
  			label: "Url",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "url"
  	},
  	poster_abstract: {
  		bib: "abstract",
  		ris: "AB",
  		csl: "abstract",
  		csv: "Abstract",
  		endnotePath: "abstract",
  		papers: "abstract",
  		input: {
  			required: false,
  			label: "Abstract",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "article.abstract"
  	},
  	poster_date: {
  		ris: "PY",
  		csl: "issued",
  		csv: "Date",
  		endnotePath: "dates.year, dates.pub-dates.date",
  		input: {
  			required: false,
  			label: "Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "date"
  	},
  	poster_access_date: {
  		bib: "urldate",
  		csl: "accessed",
  		csv: "Access Date",
  		endnotePath: "access-date",
  		papers: "accessed",
  		input: {
  			required: false,
  			label: "Access Date",
  			type: "date",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "accessed"
  	},
  	poster_short_title: {
  		bib: "shorttitle",
  		ris: "ST",
  		csl: "title-short",
  		csv: "Short Title",
  		endnotePath: "titles.short-title",
  		input: {
  			required: false,
  			label: "Short Title",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "title_short"
  	},
  	poster_place: {
  		bib: "address",
  		ris: "CY",
  		csl: "publisher-place",
  		csv: "Place",
  		endnotePath: "pub-location",
  		papers: "location",
  		input: {
  			required: false,
  			label: "Place",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event_place"
  	},
  	poster_language: {
  		bib: "language",
  		ris: "LA",
  		csl: "language",
  		csv: "Language",
  		endnotePath: "language",
  		papers: "language",
  		input: {
  			required: false,
  			label: "Language",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "language"
  	},
  	poster_rights: {
  		bib: "copyright",
  		csv: "Rights",
  		input: {
  			required: false,
  			label: "Rights",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "rights"
  	},
  	poster_type: {
  		bib: "type",
  		ris: "M3",
  		csl: "genre",
  		csv: "Type",
  		endnotePath: "misc2",
  		input: {
  			required: false,
  			label: "Type",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "genre"
  	},
  	poster_notes: {
  		bib: "note",
  		ris: "N1",
  		csl: "note",
  		csv: "Notes",
  		endnotePath: "notes",
  		input: {
  			required: false,
  			label: "Notes",
  			type: "textarea",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.notes"
  	},
  	poster_tags: {
  		bib: "keywords",
  		ris: "KW",
  		csv: "Tags",
  		endnotePath: "keywords.keyword",
  		input: {
  			required: false,
  			label: "Tags",
  			type: "text",
  			array: true,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		readcube: "user_data.tags"
  	},
  	poster_meeting_name: {
  		ris: "T2",
  		csl: "event",
  		csv: "Meeting Name",
  		endnotePath: "titles.secondary-title",
  		input: {
  			required: false,
  			label: "Meeting Name",
  			type: "text",
  			array: false,
  			pattern: null,
  			disabled: false,
  			warning: false
  		},
  		custom_metadata: "event"
  	}
  };
  var types = {
  	radio_broadcast: {
  		category: "primary",
  		csl_type: "broadcast",
  		bib_type: "misc",
  		ris_type: "SOUND",
  		csv_type: "Radio Broadcast",
  		item_type: "radio_broadcast",
  		fields: [
  			"type",
  			"radio_broadcast_title",
  			"radio_broadcast_director",
  			"radio_broadcast_contributor",
  			"radio_broadcast_cast_member",
  			"radio_broadcast_producer",
  			"radio_broadcast_scriptwriter",
  			"radio_broadcast_guest",
  			"radio_broadcast_publication_title",
  			"radio_broadcast_url",
  			"radio_broadcast_abstract",
  			"radio_broadcast_date",
  			"radio_broadcast_short_title",
  			"radio_broadcast_publisher",
  			"radio_broadcast_place",
  			"radio_broadcast_language",
  			"radio_broadcast_rights",
  			"radio_broadcast_archive",
  			"radio_broadcast_archive_location",
  			"radio_broadcast_library_catalog",
  			"radio_broadcast_call_number",
  			"radio_broadcast_notes",
  			"radio_broadcast_tags",
  			"radio_broadcast_number",
  			"radio_broadcast_running_time",
  			"radio_broadcast_medium",
  			"citekey"
  		]
  	},
  	dictionary_entry: {
  		category: "primary",
  		csl_type: "entry-dictionary",
  		bib_type: "misc",
  		ris_type: "DICT",
  		csv_type: "Dictionary Entry",
  		item_type: "dictionary_entry",
  		fields: [
  			"type",
  			"dictionary_entry_author",
  			"dictionary_entry_editor",
  			"dictionary_entry_series_editor",
  			"dictionary_entry_translator",
  			"dictionary_entry_contributor",
  			"dictionary_entry_title",
  			"dictionary_entry_publication_title",
  			"dictionary_entry_isbn",
  			"dictionary_entry_url",
  			"dictionary_entry_abstract",
  			"dictionary_entry_date",
  			"dictionary_entry_pages",
  			"dictionary_entry_volume",
  			"dictionary_entry_number_of_volumes",
  			"dictionary_entry_short_title",
  			"dictionary_entry_series",
  			"dictionary_entry_series_number",
  			"dictionary_entry_publisher",
  			"dictionary_entry_place",
  			"dictionary_entry_language",
  			"dictionary_entry_rights",
  			"dictionary_entry_archive",
  			"dictionary_entry_archive_location",
  			"dictionary_entry_library_catalog",
  			"dictionary_entry_call_number",
  			"dictionary_entry_notes",
  			"dictionary_entry_tags",
  			"dictionary_entry_edition",
  			"citekey"
  		],
  		end_type: "Dictionary"
  	},
  	encyclopedia_article: {
  		category: "primary",
  		csl_type: "entry-encyclopedia",
  		bib_type: "misc",
  		ris_type: "ENCYC",
  		csv_type: "Encyclopedia Article",
  		item_type: "encyclopedia_article",
  		fields: [
  			"type",
  			"encyclopedia_article_author",
  			"encyclopedia_article_editor",
  			"encyclopedia_article_series_editor",
  			"encyclopedia_article_translator",
  			"encyclopedia_article_contributor",
  			"encyclopedia_article_title",
  			"encyclopedia_article_publication_title",
  			"encyclopedia_article_isbn",
  			"encyclopedia_article_url",
  			"encyclopedia_article_abstract",
  			"encyclopedia_article_date",
  			"encyclopedia_article_pages",
  			"encyclopedia_article_volume",
  			"encyclopedia_article_number_of_volumes",
  			"encyclopedia_article_short_title",
  			"encyclopedia_article_series",
  			"encyclopedia_article_series_number",
  			"encyclopedia_article_publisher",
  			"encyclopedia_article_place",
  			"encyclopedia_article_language",
  			"encyclopedia_article_rights",
  			"encyclopedia_article_archive",
  			"encyclopedia_article_archive_location",
  			"encyclopedia_article_library_catalog",
  			"encyclopedia_article_call_number",
  			"encyclopedia_article_notes",
  			"encyclopedia_article_tags",
  			"encyclopedia_article_edition",
  			"citekey"
  		],
  		end_type: "Encyclopedia"
  	},
  	manuscript: {
  		category: "primary",
  		csl_type: "manuscript",
  		bib_type: "unpublished",
  		ris_type: "MANSCPT",
  		csv_type: "Manuscript",
  		item_type: "manuscript",
  		fields: [
  			"type",
  			"manuscript_author",
  			"manuscript_translator",
  			"manuscript_contributor",
  			"manuscript_title",
  			"manuscript_url",
  			"manuscript_abstract",
  			"manuscript_date",
  			"manuscript_num_pages",
  			"manuscript_short_title",
  			"manuscript_place",
  			"manuscript_language",
  			"manuscript_rights",
  			"manuscript_type",
  			"manuscript_archive",
  			"manuscript_archive_location",
  			"manuscript_library_catalog",
  			"manuscript_call_number",
  			"manuscript_notes",
  			"manuscript_tags",
  			"citekey"
  		],
  		end_type: "Manuscript"
  	},
  	email: {
  		category: "primary",
  		csl_type: "personal_communication",
  		bib_type: "misc",
  		ris_type: "ICOMM",
  		csv_type: "E-Mail",
  		item_type: "email",
  		fields: [
  			"type",
  			"email_author",
  			"email_contributor",
  			"email_recipient",
  			"email_title",
  			"email_url",
  			"email_abstract",
  			"email_date",
  			"email_access_date",
  			"email_short_title",
  			"email_language",
  			"email_rights",
  			"email_notes",
  			"email_tags",
  			"citekey"
  		]
  	},
  	instant_message: {
  		category: "primary",
  		csl_type: "personal_communication",
  		bib_type: "misc",
  		ris_type: "ICOMM",
  		csv_type: "Instant Message",
  		item_type: "instant_message",
  		fields: [
  			"type",
  			"instant_message_author",
  			"instant_message_contributor",
  			"instant_message_recipient",
  			"instant_message_title",
  			"instant_message_url",
  			"instant_message_abstract",
  			"instant_message_date",
  			"instant_message_short_title",
  			"instant_message_language",
  			"instant_message_rights",
  			"instant_message_notes",
  			"instant_message_tags",
  			"citekey"
  		]
  	},
  	letter: {
  		category: "primary",
  		csl_type: "personal_communication",
  		bib_type: "misc",
  		ris_type: "PCOMM",
  		csv_type: "Letter",
  		item_type: "letter",
  		fields: [
  			"type",
  			"letter_author",
  			"letter_contributor",
  			"letter_recipient",
  			"letter_title",
  			"letter_url",
  			"letter_abstract",
  			"letter_date",
  			"letter_access_date",
  			"letter_short_title",
  			"letter_language",
  			"letter_rights",
  			"letter_type",
  			"letter_archive",
  			"letter_archive_location",
  			"letter_library_catalog",
  			"letter_call_number",
  			"letter_notes",
  			"letter_tags",
  			"citekey"
  		]
  	},
  	forum_post: {
  		category: "primary",
  		csl_type: "post",
  		bib_type: "misc",
  		ris_type: "ICOMM",
  		csv_type: "Forum Post",
  		item_type: "forum_post",
  		fields: [
  			"type",
  			"forum_post_author",
  			"forum_post_contributor",
  			"forum_post_title",
  			"forum_post_publication_title",
  			"forum_post_url",
  			"forum_post_abstract",
  			"forum_post_date",
  			"forum_post_access_date",
  			"forum_post_short_title",
  			"forum_post_language",
  			"forum_post_rights",
  			"forum_post_type",
  			"forum_post_notes",
  			"forum_post_tags",
  			"citekey"
  		]
  	},
  	blog_post: {
  		category: "primary",
  		csl_type: "post-weblog",
  		bib_type: "misc",
  		ris_type: "BLOG",
  		csv_type: "Blog Post",
  		item_type: "blog_post",
  		fields: [
  			"type",
  			"blog_post_author",
  			"blog_post_contributor",
  			"blog_post_commenter",
  			"blog_post_title",
  			"blog_post_publication_title",
  			"blog_post_url",
  			"blog_post_abstract",
  			"blog_post_date",
  			"blog_post_access_date",
  			"blog_post_short_title",
  			"blog_post_language",
  			"blog_post_rights",
  			"blog_post_type",
  			"blog_post_notes",
  			"blog_post_tags",
  			"citekey"
  		],
  		end_type: "Blog"
  	},
  	artwork: {
  		category: "primary",
  		csl_type: "graphic",
  		bib_type: "misc",
  		ris_type: "ART",
  		csv_type: "Artwork",
  		item_type: "artwork",
  		fields: [
  			"type",
  			"artwork_artist",
  			"artwork_contributor",
  			"artwork_title",
  			"artwork_url",
  			"artwork_abstract",
  			"artwork_date",
  			"artwork_access_date",
  			"artwork_short_title",
  			"artwork_language",
  			"artwork_rights",
  			"artwork_archive",
  			"artwork_archive_location",
  			"artwork_library_catalog",
  			"artwork_call_number",
  			"artwork_notes",
  			"artwork_tags",
  			"artwork_medium",
  			"artwork_artwork_size",
  			"citekey"
  		],
  		end_type: "Artwork"
  	},
  	audio_recording: {
  		category: "primary",
  		csl_type: "song",
  		bib_type: "misc",
  		ris_type: "SOUND",
  		csv_type: "Audio Recording",
  		item_type: "audio_recording",
  		fields: [
  			"type",
  			"audio_recording_performer",
  			"audio_recording_contributor",
  			"audio_recording_composer",
  			"audio_recording_words_by",
  			"audio_recording_title",
  			"audio_recording_isbn",
  			"audio_recording_url",
  			"audio_recording_abstract",
  			"audio_recording_date",
  			"audio_recording_access_date",
  			"audio_recording_volume",
  			"audio_recording_number_of_volumes",
  			"audio_recording_short_title",
  			"audio_recording_series_title",
  			"audio_recording_publisher",
  			"audio_recording_place",
  			"audio_recording_language",
  			"audio_recording_rights",
  			"audio_recording_archive",
  			"audio_recording_archive_location",
  			"audio_recording_library_catalog",
  			"audio_recording_call_number",
  			"audio_recording_notes",
  			"audio_recording_tags",
  			"audio_recording_running_time",
  			"audio_recording_medium",
  			"citekey"
  		],
  		end_type: "Music"
  	},
  	bill: {
  		category: "primary",
  		csl_type: "bill",
  		bib_type: "misc",
  		ris_type: "BILL",
  		csv_type: "Bill",
  		item_type: "bill",
  		fields: [
  			"type",
  			"bill_sponsor",
  			"bill_contributor",
  			"bill_cosponsor",
  			"bill_title",
  			"bill_url",
  			"bill_abstract",
  			"bill_date",
  			"bill_access_date",
  			"bill_pages",
  			"bill_volume",
  			"bill_short_title",
  			"bill_language",
  			"bill_rights",
  			"bill_notes",
  			"bill_tags",
  			"bill_number",
  			"bill_code",
  			"bill_section",
  			"bill_session",
  			"bill_history",
  			"bill_legislative_body",
  			"citekey"
  		],
  		end_type: "Bill"
  	},
  	book: {
  		category: "primary",
  		csl_type: "book",
  		bib_type: "book",
  		ris_type: "BOOK",
  		csv_type: "Book",
  		item_type: "book",
  		fields: [
  			"type",
  			"book_title",
  			"book_author",
  			"book_editor",
  			"book_series_editor",
  			"book_translator",
  			"book_contributor",
  			"book_isbn",
  			"book_url",
  			"book_abstract",
  			"book_date",
  			"book_access_date",
  			"book_num_pages",
  			"book_volume",
  			"book_number_of_volumes",
  			"book_short_title",
  			"book_series",
  			"book_series_number",
  			"book_publisher",
  			"book_place",
  			"book_language",
  			"book_rights",
  			"book_archive",
  			"book_archive_location",
  			"book_library_catalog",
  			"book_call_number",
  			"book_notes",
  			"book_tags",
  			"book_edition",
  			"book_doi",
  			"citekey"
  		],
  		end_type: "Book"
  	},
  	book_section: {
  		category: "primary",
  		csl_type: "chapter",
  		bib_type: "incollection",
  		ris_type: "CHAP",
  		csv_type: "Book Section",
  		item_type: "book_section",
  		fields: [
  			"type",
  			"book_section_title",
  			"book_section_author",
  			"book_section_editor",
  			"book_section_series_editor",
  			"book_section_translator",
  			"book_section_contributor",
  			"book_section_book_author",
  			"book_section_publication_title",
  			"book_section_isbn",
  			"book_section_url",
  			"book_section_abstract",
  			"book_section_date",
  			"book_section_access_date",
  			"book_section_pages",
  			"book_section_volume",
  			"book_section_number_of_volumes",
  			"book_section_short_title",
  			"book_section_series",
  			"book_section_series_number",
  			"book_section_publisher",
  			"book_section_place",
  			"book_section_language",
  			"book_section_rights",
  			"book_section_archive",
  			"book_section_archive_location",
  			"book_section_library_catalog",
  			"book_section_call_number",
  			"book_section_notes",
  			"book_section_tags",
  			"book_section_edition",
  			"book_section_doi",
  			"citekey"
  		],
  		end_type: "Book Section"
  	},
  	"case": {
  		category: "primary",
  		csl_type: "legal_case",
  		bib_type: "misc",
  		ris_type: "CASE",
  		csv_type: "Case",
  		item_type: "case",
  		fields: [
  			"type",
  			"case_author",
  			"case_contributor",
  			"case_counsel",
  			"case_title",
  			"case_url",
  			"case_abstract",
  			"case_date",
  			"case_access_date",
  			"case_pages",
  			"case_volume",
  			"case_short_title",
  			"case_language",
  			"case_rights",
  			"case_notes",
  			"case_tags",
  			"case_number",
  			"case_court",
  			"case_reporter",
  			"case_history",
  			"citekey"
  		],
  		end_type: "Case"
  	},
  	computer_program: {
  		category: "primary",
  		csl_type: "book",
  		bib_type: "misc",
  		ris_type: "COMP",
  		csv_type: "Computer Program",
  		item_type: "computer_program",
  		fields: [
  			"type",
  			"computer_program_programmer",
  			"computer_program_contributor",
  			"computer_program_title",
  			"computer_program_isbn",
  			"computer_program_url",
  			"computer_program_abstract",
  			"computer_program_date",
  			"computer_program_short_title",
  			"computer_program_series_title",
  			"computer_program_publisher",
  			"computer_program_place",
  			"computer_program_rights",
  			"computer_program_archive",
  			"computer_program_archive_location",
  			"computer_program_library_catalog",
  			"computer_program_call_number",
  			"computer_program_notes",
  			"computer_program_tags",
  			"computer_program_programming_language",
  			"computer_program_version",
  			"computer_program_system",
  			"citekey"
  		],
  		end_type: "Computer Program"
  	},
  	conference_paper: {
  		category: "primary",
  		csl_type: "paper-conference",
  		bib_type: "inproceedings",
  		ris_type: "CONF",
  		csv_type: "Conference Paper",
  		item_type: "conference_paper",
  		fields: [
  			"type",
  			"conference_paper_author",
  			"conference_paper_editor",
  			"conference_paper_contributor",
  			"conference_paper_title",
  			"conference_paper_proceedings_title",
  			"conference_paper_type",
  			"conference_paper_isbn",
  			"conference_paper_doi",
  			"conference_paper_url",
  			"conference_paper_abstract",
  			"conference_paper_date",
  			"conference_paper_access_date",
  			"conference_paper_pages",
  			"conference_paper_volume",
  			"conference_paper_short_title",
  			"conference_paper_series",
  			"conference_paper_publisher",
  			"conference_paper_place",
  			"conference_paper_language",
  			"conference_paper_rights",
  			"conference_paper_archive",
  			"conference_paper_archive_location",
  			"conference_paper_library_catalog",
  			"conference_paper_call_number",
  			"conference_paper_notes",
  			"conference_paper_tags",
  			"conference_paper_conference_name",
  			"citekey"
  		],
  		end_type: "Conference Paper"
  	},
  	document: {
  		category: "primary",
  		csl_type: "article",
  		bib_type: "misc",
  		ris_type: "GEN",
  		csv_type: "Document",
  		item_type: "document",
  		fields: [
  			"type",
  			"document_author",
  			"document_editor",
  			"document_translator",
  			"document_contributor",
  			"document_title",
  			"document_url",
  			"document_abstract",
  			"document_date",
  			"document_access_date",
  			"document_short_title",
  			"document_publisher",
  			"document_language",
  			"document_rights",
  			"document_archive",
  			"document_archive_location",
  			"document_library_catalog",
  			"document_call_number",
  			"document_notes",
  			"document_tags",
  			"citekey"
  		],
  		end_type: "Aggregated Database"
  	},
  	film: {
  		category: "primary",
  		csl_type: "motion_picture",
  		bib_type: "misc",
  		ris_type: "MPCT",
  		csv_type: "Film",
  		item_type: "film",
  		fields: [
  			"type",
  			"film_director",
  			"film_contributor",
  			"film_producer",
  			"film_scriptwriter",
  			"film_title",
  			"film_url",
  			"film_abstract",
  			"film_date",
  			"film_access_date",
  			"film_short_title",
  			"film_publisher",
  			"film_language",
  			"film_rights",
  			"film_type",
  			"film_archive",
  			"film_archive_location",
  			"film_library_catalog",
  			"film_call_number",
  			"film_notes",
  			"film_tags",
  			"film_running_time",
  			"film_medium",
  			"citekey"
  		],
  		end_type: "Film or Broadcast"
  	},
  	hearing: {
  		category: "primary",
  		csl_type: "bill",
  		bib_type: "misc",
  		ris_type: "HEAR",
  		csv_type: "Hearing",
  		item_type: "hearing",
  		fields: [
  			"type",
  			"hearing_contributor",
  			"hearing_title",
  			"hearing_url",
  			"hearing_abstract",
  			"hearing_date",
  			"hearing_pages",
  			"hearing_number_of_volumes",
  			"hearing_short_title",
  			"hearing_publisher",
  			"hearing_place",
  			"hearing_language",
  			"hearing_rights",
  			"hearing_notes",
  			"hearing_tags",
  			"hearing_number",
  			"hearing_session",
  			"hearing_committee",
  			"hearing_history",
  			"hearing_legislative_body",
  			"citekey"
  		],
  		end_type: "Hearing"
  	},
  	interview: {
  		category: "primary",
  		csl_type: "interview",
  		bib_type: "misc",
  		ris_type: "PCOMM",
  		csv_type: "Interview",
  		item_type: "interview",
  		fields: [
  			"type",
  			"interview_interview_with",
  			"interview_contributor",
  			"interview_title",
  			"interview_url",
  			"interview_abstract",
  			"interview_date",
  			"interview_access_date",
  			"interview_short_title",
  			"interview_language",
  			"interview_rights",
  			"interview_archive",
  			"interview_archive_location",
  			"interview_library_catalog",
  			"interview_call_number",
  			"interview_notes",
  			"interview_tags",
  			"interview_medium",
  			"citekey"
  		],
  		end_type: "Personal Communication"
  	},
  	article: {
  		category: "primary",
  		csl_type: "article-journal",
  		bib_type: "article",
  		ris_type: "JOUR",
  		csv_type: "Journal Article",
  		item_type: "article",
  		fields: [
  			"type",
  			"article_title",
  			"article_author",
  			"article_journal",
  			"article_issn",
  			"article_doi",
  			"article_pmid",
  			"article_pmcid",
  			"article_arxiv",
  			"article_url",
  			"article_abstract",
  			"article_date",
  			"article_journal_abbreviation",
  			"article_short_title",
  			"article_editor",
  			"article_translator",
  			"article_contributor",
  			"article_reviewed_author",
  			"article_publication_title",
  			"article_pages",
  			"article_issue",
  			"article_volume",
  			"article_series",
  			"article_series_text",
  			"article_language",
  			"article_rights",
  			"article_archive",
  			"article_archive_location",
  			"article_library_catalog",
  			"article_call_number",
  			"article_notes",
  			"article_tags",
  			"citekey"
  		],
  		end_type: "Electronic Article",
  		is_default: true
  	},
  	magazine: {
  		category: "primary",
  		csl_type: "article-magazine",
  		bib_type: "article",
  		ris_type: "MGZN",
  		csv_type: "Magazine",
  		item_type: "magazine",
  		fields: [
  			"type",
  			"magazine_author",
  			"magazine_translator",
  			"magazine_contributor",
  			"magazine_reviewed_author",
  			"magazine_title",
  			"magazine_publication_title",
  			"magazine_issn",
  			"magazine_url",
  			"magazine_abstract",
  			"magazine_date",
  			"magazine_access_date",
  			"magazine_pages",
  			"magazine_issue",
  			"magazine_volume",
  			"magazine_short_title",
  			"magazine_language",
  			"magazine_rights",
  			"magazine_archive",
  			"magazine_archive_location",
  			"magazine_library_catalog",
  			"magazine_call_number",
  			"magazine_notes",
  			"magazine_tags",
  			"citekey"
  		],
  		end_type: "Catalog"
  	},
  	map: {
  		category: "primary",
  		csl_type: "map",
  		bib_type: "misc",
  		ris_type: "MAP",
  		csv_type: "Map",
  		item_type: "map",
  		fields: [
  			"type",
  			"map_cartographer",
  			"map_series_editor",
  			"map_contributor",
  			"map_title",
  			"map_isbn",
  			"map_url",
  			"map_abstract",
  			"map_date",
  			"map_access_date",
  			"map_short_title",
  			"map_series_title",
  			"map_publisher",
  			"map_place",
  			"map_language",
  			"map_rights",
  			"map_type",
  			"map_archive",
  			"map_archive_location",
  			"map_library_catalog",
  			"map_call_number",
  			"map_notes",
  			"map_tags",
  			"map_edition",
  			"map_scale",
  			"citekey"
  		],
  		end_type: "Map"
  	},
  	newspaper_article: {
  		category: "primary",
  		csl_type: "article-newspaper",
  		bib_type: "article",
  		ris_type: "NEWS",
  		csv_type: "Newspaper Article",
  		item_type: "newspaper_article",
  		fields: [
  			"type",
  			"newspaper_article_author",
  			"newspaper_article_translator",
  			"newspaper_article_contributor",
  			"newspaper_article_reviewed_author",
  			"newspaper_article_title",
  			"newspaper_article_publication_title",
  			"newspaper_article_issn",
  			"newspaper_article_url",
  			"newspaper_article_abstract",
  			"newspaper_article_date",
  			"newspaper_article_pages",
  			"newspaper_article_short_title",
  			"newspaper_article_place",
  			"newspaper_article_language",
  			"newspaper_article_rights",
  			"newspaper_article_archive",
  			"newspaper_article_archive_location",
  			"newspaper_article_library_catalog",
  			"newspaper_article_call_number",
  			"newspaper_article_notes",
  			"newspaper_article_tags",
  			"newspaper_article_edition",
  			"newspaper_article_section",
  			"citekey"
  		],
  		end_type: "Newspaper Article"
  	},
  	patent: {
  		category: "primary",
  		csl_type: "patent",
  		bib_type: "patent",
  		ris_type: "PAT",
  		csv_type: "Patent",
  		item_type: "patent",
  		fields: [
  			"type",
  			"patent_title",
  			"patent_inventor",
  			"patent_contributor",
  			"patent_patent_id",
  			"patent_application_number",
  			"patent_guest",
  			"patent_attorney_agent",
  			"patent_url",
  			"patent_abstract",
  			"patent_date",
  			"patent_access_date",
  			"patent_pages",
  			"patent_short_title",
  			"patent_place",
  			"patent_language",
  			"patent_rights",
  			"patent_notes",
  			"patent_tags",
  			"patent_number",
  			"patent_filing_date",
  			"patent_publication_date",
  			"patent_assignee",
  			"patent_issuing_authority",
  			"patent_country",
  			"patent_references",
  			"patent_legal_status",
  			"patent_priority_numbers",
  			"citekey"
  		],
  		end_type: "Patent"
  	},
  	podcast: {
  		category: "primary",
  		csl_type: "broadcast",
  		bib_type: "misc",
  		ris_type: "SOUND",
  		csv_type: "Podcast",
  		item_type: "podcast",
  		fields: [
  			"type",
  			"podcast_podcaster",
  			"podcast_title",
  			"podcast_url",
  			"podcast_abstract",
  			"podcast_access_date",
  			"podcast_short_title",
  			"podcast_series_title",
  			"podcast_language",
  			"podcast_rights",
  			"podcast_notes",
  			"podcast_tags",
  			"podcast_number",
  			"podcast_running_time",
  			"podcast_medium",
  			"citekey"
  		]
  	},
  	presentation: {
  		category: "primary",
  		csl_type: "speech",
  		bib_type: "misc",
  		ris_type: "SLIDE",
  		csv_type: "Presentation",
  		item_type: "presentation",
  		fields: [
  			"type",
  			"presentation_presenter",
  			"presentation_contributor",
  			"presentation_title",
  			"presentation_url",
  			"presentation_abstract",
  			"presentation_date",
  			"presentation_access_date",
  			"presentation_short_title",
  			"presentation_place",
  			"presentation_language",
  			"presentation_rights",
  			"presentation_type",
  			"presentation_notes",
  			"presentation_tags",
  			"presentation_meeting_name",
  			"citekey"
  		]
  	},
  	report: {
  		category: "primary",
  		csl_type: "report",
  		bib_type: "techreport",
  		ris_type: "RPRT",
  		csv_type: "Report",
  		item_type: "report",
  		fields: [
  			"type",
  			"report_author",
  			"report_series_editor",
  			"report_contributor",
  			"report_title",
  			"report_url",
  			"report_access_date",
  			"report_abstract",
  			"report_date",
  			"report_pages",
  			"report_short_title",
  			"report_series_title",
  			"report_publisher",
  			"report_place",
  			"report_language",
  			"report_rights",
  			"report_type",
  			"report_archive",
  			"report_archive_location",
  			"report_library_catalog",
  			"report_call_number",
  			"report_notes",
  			"report_tags",
  			"report_number",
  			"citekey"
  		],
  		end_type: "Government Document"
  	},
  	statute: {
  		category: "primary",
  		csl_type: "legislation",
  		bib_type: "misc",
  		ris_type: "STAT",
  		csv_type: "Statute",
  		item_type: "statute",
  		fields: [
  			"type",
  			"statute_author",
  			"statute_contributor",
  			"statute_title",
  			"statute_url",
  			"statute_abstract",
  			"statute_date",
  			"statute_access_date",
  			"statute_pages",
  			"statute_short_title",
  			"statute_language",
  			"statute_rights",
  			"statute_notes",
  			"statute_tags",
  			"statute_number",
  			"statute_code",
  			"statute_code_number",
  			"statute_section",
  			"statute_session",
  			"statute_history",
  			"citekey"
  		],
  		end_type: "Statute"
  	},
  	thesis: {
  		category: "primary",
  		csl_type: "thesis",
  		bib_type: "phdthesis",
  		ris_type: "THES",
  		csv_type: "Thesis",
  		item_type: "thesis",
  		fields: [
  			"type",
  			"thesis_title",
  			"thesis_author",
  			"thesis_contributor",
  			"thesis_abstract",
  			"thesis_tags",
  			"thesis_date",
  			"thesis_publisher",
  			"thesis_notes",
  			"citekey"
  		],
  		end_type: "Thesis"
  	},
  	tv_broadcast: {
  		category: "primary",
  		csl_type: "broadcast",
  		bib_type: "misc",
  		ris_type: "MPCT",
  		csv_type: "TV Broadcast",
  		item_type: "tv_broadcast",
  		fields: [
  			"type",
  			"tv_broadcast_director",
  			"tv_broadcast_cast_member",
  			"tv_broadcast_producer",
  			"tv_broadcast_scriptwriter",
  			"tv_broadcast_guest",
  			"tv_broadcast_title",
  			"tv_broadcast_publication_title",
  			"tv_broadcast_url",
  			"tv_broadcast_abstract",
  			"tv_broadcast_date",
  			"tv_broadcast_access_date",
  			"tv_broadcast_short_title",
  			"tv_broadcast_publisher",
  			"tv_broadcast_place",
  			"tv_broadcast_language",
  			"tv_broadcast_rights",
  			"tv_broadcast_archive",
  			"tv_broadcast_archive_location",
  			"tv_broadcast_library_catalog",
  			"tv_broadcast_call_number",
  			"tv_broadcast_notes",
  			"tv_broadcast_tags",
  			"tv_broadcast_number",
  			"tv_broadcast_running_time",
  			"tv_broadcast_medium",
  			"citekey"
  		]
  	},
  	video_recording: {
  		category: "primary",
  		csl_type: "motion_picture",
  		bib_type: "misc",
  		ris_type: "VIDEO",
  		csv_type: "Video Recording",
  		item_type: "video_recording",
  		fields: [
  			"type",
  			"video_recording_director",
  			"video_recording_contributor",
  			"video_recording_cast_member",
  			"video_recording_producer",
  			"video_recording_scriptwriter",
  			"video_recording_title",
  			"video_recording_isbn",
  			"video_recording_url",
  			"video_recording_abstract",
  			"video_recording_date",
  			"video_recording_access_date",
  			"video_recording_volume",
  			"video_recording_number_of_volumes",
  			"video_recording_short_title",
  			"video_recording_series_title",
  			"video_recording_publisher",
  			"video_recording_place",
  			"video_recording_language",
  			"video_recording_rights",
  			"video_recording_archive",
  			"video_recording_archive_location",
  			"video_recording_library_catalog",
  			"video_recording_call_number",
  			"video_recording_notes",
  			"video_recording_tags",
  			"video_recording_running_time",
  			"video_recording_medium",
  			"citekey"
  		],
  		end_type: "Audiovisual Material"
  	},
  	webpage: {
  		category: "primary",
  		csl_type: "webpage",
  		bib_type: "misc",
  		ris_type: "ELEC",
  		csv_type: "Web Page",
  		item_type: "webpage",
  		fields: [
  			"type",
  			"webpage_title",
  			"webpage_author",
  			"webpage_url",
  			"webpage_access_date",
  			"webpage_translator",
  			"webpage_contributor",
  			"webpage_publication_title",
  			"webpage_abstract",
  			"webpage_date",
  			"webpage_short_title",
  			"webpage_language",
  			"webpage_rights",
  			"webpage_type",
  			"webpage_notes",
  			"webpage_tags",
  			"citekey"
  		],
  		end_type: "Web Page"
  	},
  	abstract: {
  		category: "primary",
  		csl_type: "paper-conference",
  		bib_type: "misc",
  		ris_type: "ABST",
  		csv_type: "Abstract",
  		item_type: "abstract",
  		fields: [
  			"type",
  			"abstract_author",
  			"abstract_editor",
  			"abstract_contributor",
  			"abstract_title",
  			"abstract_proceedings_title",
  			"abstract_type",
  			"abstract_isbn",
  			"abstract_doi",
  			"abstract_url",
  			"abstract_abstract",
  			"abstract_date",
  			"abstract_access_date",
  			"abstract_pages",
  			"abstract_volume",
  			"abstract_short_title",
  			"abstract_series",
  			"abstract_publisher",
  			"abstract_place",
  			"abstract_language",
  			"abstract_rights",
  			"abstract_archive",
  			"abstract_archive_location",
  			"abstract_library_catalog",
  			"abstract_call_number",
  			"abstract_notes",
  			"abstract_tags",
  			"abstract_conference_name",
  			"citekey"
  		]
  	},
  	poster: {
  		category: "primary",
  		csl_type: "speech",
  		bib_type: "misc",
  		ris_type: "SLIDE",
  		csv_type: "Poster",
  		item_type: "poster",
  		fields: [
  			"type",
  			"poster_presenter",
  			"poster_contributor",
  			"poster_title",
  			"poster_url",
  			"poster_abstract",
  			"poster_date",
  			"poster_access_date",
  			"poster_short_title",
  			"poster_place",
  			"poster_language",
  			"poster_rights",
  			"poster_type",
  			"poster_notes",
  			"poster_tags",
  			"poster_meeting_name",
  			"citekey"
  		]
  	}
  };
  var papermill_sources = {
  	"$.submission_date": {
  		data_type: "papers_99_date"
  	},
  	"$.revision_date": {
  		data_type: "papers_99_date"
  	},
  	"$.accepted_date": {
  		data_type: "papers_99_date"
  	},
  	"$.publication_date": {
  		data_type: "papers_99_date"
  	},
  	"$.read_status": {
  		data_type: "papers_int_boolean"
  	},
  	"$.matched": {
  		data_type: "papers_simple_int_boolean"
  	},
  	"$.printed_date": {
  		data_type: "papers_timestamp_boolean"
  	},
  	"$.full_editor_string": {
  		data_type: "papers_and_delimited_string"
  	},
  	"$.full_author_string": {
  		data_type: "papers_and_delimited_string"
  	},
  	"$.full_translator_string": {
  		data_type: "papers_and_delimited_string"
  	},
  	"$.authors[*].fullname": {
  		data_type: "array"
  	},
  	"$.imported_date": {
  		data_type: "papers_timestamp"
  	}
  };
  var nonuser = [
  	"imported",
  	"times_read"
  ];
  var meta = {
  	field_defs: field_defs,
  	types: types,
  	papermill_sources: papermill_sources,
  	nonuser: nonuser
  };

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function getDefaultExportFromCjs (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  var defaultTypeNameFromMapping = (mapping) => {
    const match =
      Object
        .entries(mapping.types)
        .find(entry => {
          const [typeName, typeDef] = entry;
          return typeDef.is_default === true
        });

      return match && match[0]
    };

  const format$2 = (out, newLine) => {
      const nl = getNewLine(newLine);
      // this is a workaround for Endnote
      // which requires us to have the following if PMID is present:
      //
      // XX  - <empty line>
      // PMID  - <value>
      // ER  -
      const pmidIndex = out
          .findIndex((entry) => entry[0] === "PMID");
      if (pmidIndex > -1) {
          const pmidEntry = out.splice(pmidIndex, 1)[0];
          out.splice(out.length - 1, 0, ["XX", ""], pmidEntry);
      }
      const frmt = out
          .map((entry) => {
          const [key, value] = entry;
          return `${key}  - ${value}`;
      })
          .join(nl);
      return frmt + nl;
  };

  function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
      return NaN;
    }

    var number = Number(dirtyNumber);

    if (isNaN(number)) {
      return number;
    }

    return number < 0 ? Math.ceil(number) : Math.floor(number);
  }

  function requiredArgs(required, args) {
    if (args.length < required) {
      throw new TypeError(required + ' argument' + required > 1 ? 's' : '' + ' required, but only ' + args.length + ' present');
    }
  }

  /**
   * @name toDate
   * @category Common Helpers
   * @summary Convert the given argument to an instance of Date.
   *
   * @description
   * Convert the given argument to an instance of Date.
   *
   * If the argument is an instance of Date, the function returns its clone.
   *
   * If the argument is a number, it is treated as a timestamp.
   *
   * If the argument is none of the above, the function returns Invalid Date.
   *
   * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
   *
   * @param {Date|Number} argument - the value to convert
   * @returns {Date} the parsed date in the local time zone
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Clone the date:
   * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
   * //=> Tue Feb 11 2014 11:30:30
   *
   * @example
   * // Convert the timestamp to date:
   * const result = toDate(1392098430000)
   * //=> Tue Feb 11 2014 11:30:30
   */

  function toDate(argument) {
    requiredArgs(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date

    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
      // Prevent the date to lose the milliseconds when passed to new Date() in IE10
      return new Date(argument.getTime());
    } else if (typeof argument === 'number' || argStr === '[object Number]') {
      return new Date(argument);
    } else {
      if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

        console.warn(new Error().stack);
      }

      return new Date(NaN);
    }
  }

  /**
   * @name addMilliseconds
   * @category Millisecond Helpers
   * @summary Add the specified number of milliseconds to the given date.
   *
   * @description
   * Add the specified number of milliseconds to the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of milliseconds to be added
   * @returns {Date} the new date with the milliseconds added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
   * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
   * //=> Thu Jul 10 2014 12:45:30.750
   */

  function addMilliseconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var timestamp = toDate(dirtyDate).getTime();
    var amount = toInteger(dirtyAmount);
    return new Date(timestamp + amount);
  }

  var MILLISECONDS_IN_MINUTE$1 = 60000;
  /**
   * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
   * They usually appear for dates that denote time before the timezones were introduced
   * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
   * and GMT+01:00:00 after that date)
   *
   * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
   * which would lead to incorrect calculations.
   *
   * This function returns the timezone offset in milliseconds that takes seconds in account.
   */

  function getTimezoneOffsetInMilliseconds(dirtyDate) {
    var date = new Date(dirtyDate.getTime());
    var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
    date.setSeconds(0, 0);
    var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE$1;
    return baseTimezoneOffset * MILLISECONDS_IN_MINUTE$1 + millisecondsPartOfTimezoneOffset;
  }

  /**
   * @name isValid
   * @category Common Helpers
   * @summary Is the given date valid?
   *
   * @description
   * Returns false if argument is Invalid Date and true otherwise.
   * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
   * Invalid Date is a Date, whose time value is NaN.
   *
   * Time value of Date: http://es5.github.io/#x15.9.1.1
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * - Now `isValid` doesn't throw an exception
   *   if the first argument is not an instance of Date.
   *   Instead, argument is converted beforehand using `toDate`.
   *
   *   Examples:
   *
   *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
   *   |---------------------------|---------------|---------------|
   *   | `new Date()`              | `true`        | `true`        |
   *   | `new Date('2016-01-01')`  | `true`        | `true`        |
   *   | `new Date('')`            | `false`       | `false`       |
   *   | `new Date(1488370835081)` | `true`        | `true`        |
   *   | `new Date(NaN)`           | `false`       | `false`       |
   *   | `'2016-01-01'`            | `TypeError`   | `false`       |
   *   | `''`                      | `TypeError`   | `false`       |
   *   | `1488370835081`           | `TypeError`   | `true`        |
   *   | `NaN`                     | `TypeError`   | `false`       |
   *
   *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
   *   that try to coerce arguments to the expected type
   *   (which is also the case with other *date-fns* functions).
   *
   * @param {*} date - the date to check
   * @returns {Boolean} the date is valid
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // For the valid date:
   * var result = isValid(new Date(2014, 1, 31))
   * //=> true
   *
   * @example
   * // For the value, convertable into a date:
   * var result = isValid(1393804800000)
   * //=> true
   *
   * @example
   * // For the invalid date:
   * var result = isValid(new Date(''))
   * //=> false
   */

  function isValid(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    return !isNaN(date);
  }

  var formatDistanceLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },
    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },
    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },
    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },
    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },
    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },
    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },
    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },
    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },
    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },
    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },
    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  };
  function formatDistance(token, count, options) {
    options = options || {};
    var result;

    if (typeof formatDistanceLocale[token] === 'string') {
      result = formatDistanceLocale[token];
    } else if (count === 1) {
      result = formatDistanceLocale[token].one;
    } else {
      result = formatDistanceLocale[token].other.replace('{{count}}', count);
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result;
      } else {
        return result + ' ago';
      }
    }

    return result;
  }

  function buildFormatLongFn(args) {
    return function (dirtyOptions) {
      var options = dirtyOptions || {};
      var width = options.width ? String(options.width) : args.defaultWidth;
      var format = args.formats[width] || args.formats[args.defaultWidth];
      return format;
    };
  }

  var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
  };
  var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
  };
  var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
  };
  var formatLong = {
    date: buildFormatLongFn({
      formats: dateFormats,
      defaultWidth: 'full'
    }),
    time: buildFormatLongFn({
      formats: timeFormats,
      defaultWidth: 'full'
    }),
    dateTime: buildFormatLongFn({
      formats: dateTimeFormats,
      defaultWidth: 'full'
    })
  };
  var formatLong$1 = formatLong;

  var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
  };
  function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
  }

  function buildLocalizeFn(args) {
    return function (dirtyIndex, dirtyOptions) {
      var options = dirtyOptions || {};
      var context = options.context ? String(options.context) : 'standalone';
      var valuesArray;

      if (context === 'formatting' && args.formattingValues) {
        var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
        var width = options.width ? String(options.width) : defaultWidth;
        valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
      } else {
        var _defaultWidth = args.defaultWidth;

        var _width = options.width ? String(options.width) : args.defaultWidth;

        valuesArray = args.values[_width] || args.values[_defaultWidth];
      }

      var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
      return valuesArray[index];
    };
  }

  var eraValues = {
    narrow: ['B', 'A'],
    abbreviated: ['BC', 'AD'],
    wide: ['Before Christ', 'Anno Domini']
  };
  var quarterValues = {
    narrow: ['1', '2', '3', '4'],
    abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
    wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
    // If you are making a new locale based on this one, check if the same is true for the language you're working on.
    // Generally, formatted dates should look like they are in the middle of a sentence,
    // e.g. in Spanish language the weekdays and months should be in the lowercase.

  };
  var monthValues = {
    narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
    abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  };
  var dayValues = {
    narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  };
  var dayPeriodValues = {
    narrow: {
      am: 'a',
      pm: 'p',
      midnight: 'mi',
      noon: 'n',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    },
    abbreviated: {
      am: 'AM',
      pm: 'PM',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    },
    wide: {
      am: 'a.m.',
      pm: 'p.m.',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    }
  };
  var formattingDayPeriodValues = {
    narrow: {
      am: 'a',
      pm: 'p',
      midnight: 'mi',
      noon: 'n',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night'
    },
    abbreviated: {
      am: 'AM',
      pm: 'PM',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night'
    },
    wide: {
      am: 'a.m.',
      pm: 'p.m.',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night'
    }
  };

  function ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'

    var rem100 = number % 100;

    if (rem100 > 20 || rem100 < 10) {
      switch (rem100 % 10) {
        case 1:
          return number + 'st';

        case 2:
          return number + 'nd';

        case 3:
          return number + 'rd';
      }
    }

    return number + 'th';
  }

  var localize = {
    ordinalNumber: ordinalNumber,
    era: buildLocalizeFn({
      values: eraValues,
      defaultWidth: 'wide'
    }),
    quarter: buildLocalizeFn({
      values: quarterValues,
      defaultWidth: 'wide',
      argumentCallback: function (quarter) {
        return Number(quarter) - 1;
      }
    }),
    month: buildLocalizeFn({
      values: monthValues,
      defaultWidth: 'wide'
    }),
    day: buildLocalizeFn({
      values: dayValues,
      defaultWidth: 'wide'
    }),
    dayPeriod: buildLocalizeFn({
      values: dayPeriodValues,
      defaultWidth: 'wide',
      formattingValues: formattingDayPeriodValues,
      defaultFormattingWidth: 'wide'
    })
  };
  var localize$1 = localize;

  function buildMatchPatternFn(args) {
    return function (dirtyString, dirtyOptions) {
      var string = String(dirtyString);
      var options = dirtyOptions || {};
      var matchResult = string.match(args.matchPattern);

      if (!matchResult) {
        return null;
      }

      var matchedString = matchResult[0];
      var parseResult = string.match(args.parsePattern);

      if (!parseResult) {
        return null;
      }

      var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
      value = options.valueCallback ? options.valueCallback(value) : value;
      return {
        value: value,
        rest: string.slice(matchedString.length)
      };
    };
  }

  function buildMatchFn(args) {
    return function (dirtyString, dirtyOptions) {
      var string = String(dirtyString);
      var options = dirtyOptions || {};
      var width = options.width;
      var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
      var matchResult = string.match(matchPattern);

      if (!matchResult) {
        return null;
      }

      var matchedString = matchResult[0];
      var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
      var value;

      if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
        value = findIndex(parsePatterns, function (pattern) {
          return pattern.test(string);
        });
      } else {
        value = findKey(parsePatterns, function (pattern) {
          return pattern.test(string);
        });
      }

      value = args.valueCallback ? args.valueCallback(value) : value;
      value = options.valueCallback ? options.valueCallback(value) : value;
      return {
        value: value,
        rest: string.slice(matchedString.length)
      };
    };
  }

  function findKey(object, predicate) {
    for (var key in object) {
      if (object.hasOwnProperty(key) && predicate(object[key])) {
        return key;
      }
    }
  }

  function findIndex(array, predicate) {
    for (var key = 0; key < array.length; key++) {
      if (predicate(array[key])) {
        return key;
      }
    }
  }

  var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
  var parseOrdinalNumberPattern = /\d+/i;
  var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  };
  var parseEraPatterns = {
    any: [/^b/i, /^(a|c)/i]
  };
  var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  };
  var parseQuarterPatterns = {
    any: [/1/i, /2/i, /3/i, /4/i]
  };
  var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  };
  var parseMonthPatterns = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  };
  var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  };
  var parseDayPatterns = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  };
  var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  };
  var parseDayPeriodPatterns = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  };
  var match = {
    ordinalNumber: buildMatchPatternFn({
      matchPattern: matchOrdinalNumberPattern,
      parsePattern: parseOrdinalNumberPattern,
      valueCallback: function (value) {
        return parseInt(value, 10);
      }
    }),
    era: buildMatchFn({
      matchPatterns: matchEraPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseEraPatterns,
      defaultParseWidth: 'any'
    }),
    quarter: buildMatchFn({
      matchPatterns: matchQuarterPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseQuarterPatterns,
      defaultParseWidth: 'any',
      valueCallback: function (index) {
        return index + 1;
      }
    }),
    month: buildMatchFn({
      matchPatterns: matchMonthPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseMonthPatterns,
      defaultParseWidth: 'any'
    }),
    day: buildMatchFn({
      matchPatterns: matchDayPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseDayPatterns,
      defaultParseWidth: 'any'
    }),
    dayPeriod: buildMatchFn({
      matchPatterns: matchDayPeriodPatterns,
      defaultMatchWidth: 'any',
      parsePatterns: parseDayPeriodPatterns,
      defaultParseWidth: 'any'
    })
  };
  var match$1 = match;

  /**
   * @type {Locale}
   * @category Locales
   * @summary English locale (United States).
   * @language English
   * @iso-639-2 eng
   * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
   * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
   */

  var locale = {
    code: 'en-US',
    formatDistance: formatDistance,
    formatLong: formatLong$1,
    formatRelative: formatRelative,
    localize: localize$1,
    match: match$1,
    options: {
      weekStartsOn: 0
      /* Sunday */
      ,
      firstWeekContainsDate: 1
    }
  };
  var defaultLocale = locale;

  /**
   * @name subMilliseconds
   * @category Millisecond Helpers
   * @summary Subtract the specified number of milliseconds from the given date.
   *
   * @description
   * Subtract the specified number of milliseconds from the given date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of milliseconds to be subtracted
   * @returns {Date} the new date with the milliseconds subtracted
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
   * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
   * //=> Thu Jul 10 2014 12:45:29.250
   */

  function subMilliseconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMilliseconds(dirtyDate, -amount);
  }

  function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();

    while (output.length < targetLength) {
      output = '0' + output;
    }

    return sign + output;
  }

  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* |                                |
   * |  d  | Day of month                   |  D  |                                |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  m  | Minute                         |  M  | Month                          |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  y  | Year (abs)                     |  Y  |                                |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   */

  var formatters$2 = {
    // Year
    y: function (date, token) {
      // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
      // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
      // |----------|-------|----|-------|-------|-------|
      // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
      // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
      // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
      // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
      // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function (date, token) {
      var month = date.getUTCMonth();
      return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
    },
    // Day of the month
    d: function (date, token) {
      return addLeadingZeros(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function (date, token) {
      var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return dayPeriodEnumValue.toUpperCase();

        case 'aaaaa':
          return dayPeriodEnumValue[0];

        case 'aaaa':
        default:
          return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
      }
    },
    // Hour [1-12]
    h: function (date, token) {
      return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function (date, token) {
      return addLeadingZeros(date.getUTCHours(), token.length);
    },
    // Minute
    m: function (date, token) {
      return addLeadingZeros(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function (date, token) {
      return addLeadingZeros(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function (date, token) {
      var numberOfDigits = token.length;
      var milliseconds = date.getUTCMilliseconds();
      var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
      return addLeadingZeros(fractionalSeconds, token.length);
    }
  };
  var formatters$3 = formatters$2;

  var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
  // See issue: https://github.com/date-fns/date-fns/issues/376

  function getUTCDayOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
  }

  // See issue: https://github.com/date-fns/date-fns/issues/376

  function startOfUTCISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var weekStartsOn = 1;
    var date = toDate(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

  // See issue: https://github.com/date-fns/date-fns/issues/376

  function getUTCISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

    if (date.getTime() >= startOfNextYear.getTime()) {
      return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
      return year;
    } else {
      return year - 1;
    }
  }

  // See issue: https://github.com/date-fns/date-fns/issues/376

  function startOfUTCISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var year = getUTCISOWeekYear(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = startOfUTCISOWeek(fourthOfJanuary);
    return date;
  }

  var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
  // See issue: https://github.com/date-fns/date-fns/issues/376

  function getUTCISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)

    return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
  }

  // See issue: https://github.com/date-fns/date-fns/issues/376

  function startOfUTCWeek(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }

    var date = toDate(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

  // See issue: https://github.com/date-fns/date-fns/issues/376

  function getUTCWeekYear(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    }

    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

    if (date.getTime() >= startOfNextYear.getTime()) {
      return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
      return year;
    } else {
      return year - 1;
    }
  }

  // See issue: https://github.com/date-fns/date-fns/issues/376

  function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
    var year = getUTCWeekYear(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = startOfUTCWeek(firstWeek, dirtyOptions);
    return date;
  }

  var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
  // See issue: https://github.com/date-fns/date-fns/issues/376

  function getUTCWeek(dirtyDate, options) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)

    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
  }

  var dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
    /*
     * |     | Unit                           |     | Unit                           |
     * |-----|--------------------------------|-----|--------------------------------|
     * |  a  | AM, PM                         |  A* | Milliseconds in day            |
     * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
     * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
     * |  d  | Day of month                   |  D  | Day of year                    |
     * |  e  | Local day of week              |  E  | Day of week                    |
     * |  f  |                                |  F* | Day of week in month           |
     * |  g* | Modified Julian day            |  G  | Era                            |
     * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
     * |  i! | ISO day of week                |  I! | ISO week of year               |
     * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
     * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
     * |  l* | (deprecated)                   |  L  | Stand-alone month              |
     * |  m  | Minute                         |  M  | Month                          |
     * |  n  |                                |  N  |                                |
     * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
     * |  p! | Long localized time            |  P! | Long localized date            |
     * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
     * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
     * |  s  | Second                         |  S  | Fraction of second             |
     * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
     * |  u  | Extended year                  |  U* | Cyclic year                    |
     * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
     * |  w  | Local week of year             |  W* | Week of month                  |
     * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
     * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
     * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
     *
     * Letters marked by * are not implemented but reserved by Unicode standard.
     *
     * Letters marked by ! are non-standard, but implemented by date-fns:
     * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
     * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
     *   i.e. 7 for Sunday, 1 for Monday, etc.
     * - `I` is ISO week of year, as opposed to `w` which is local week of year.
     * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
     *   `R` is supposed to be used in conjunction with `I` and `i`
     *   for universal ISO week-numbering date, whereas
     *   `Y` is supposed to be used in conjunction with `w` and `e`
     *   for week-numbering date specific to the locale.
     * - `P` is long localized date format
     * - `p` is long localized time format
     */

  };
  var formatters = {
    // Era
    G: function (date, token, localize) {
      var era = date.getUTCFullYear() > 0 ? 1 : 0;

      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return localize.era(era, {
            width: 'abbreviated'
          });
        // A, B

        case 'GGGGG':
          return localize.era(era, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return localize.era(era, {
            width: 'wide'
          });
      }
    },
    // Year
    y: function (date, token, localize) {
      // Ordinal number
      if (token === 'yo') {
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return localize.ordinalNumber(year, {
          unit: 'year'
        });
      }

      return formatters$3.y(date, token);
    },
    // Local week-numbering year
    Y: function (date, token, localize, options) {
      var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

      if (token === 'YY') {
        var twoDigitYear = weekYear % 100;
        return addLeadingZeros(twoDigitYear, 2);
      } // Ordinal number


      if (token === 'Yo') {
        return localize.ordinalNumber(weekYear, {
          unit: 'year'
        });
      } // Padding


      return addLeadingZeros(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function (date, token) {
      var isoWeekYear = getUTCISOWeekYear(date); // Padding

      return addLeadingZeros(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function (date, token) {
      var year = date.getUTCFullYear();
      return addLeadingZeros(year, token.length);
    },
    // Quarter
    Q: function (date, token, localize) {
      var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
          return String(quarter);
        // 01, 02, 03, 04

        case 'QQ':
          return addLeadingZeros(quarter, 2);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return localize.ordinalNumber(quarter, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return localize.quarter(quarter, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return localize.quarter(quarter, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return localize.quarter(quarter, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Stand-alone quarter
    q: function (date, token, localize) {
      var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

      switch (token) {
        // 1, 2, 3, 4
        case 'q':
          return String(quarter);
        // 01, 02, 03, 04

        case 'qq':
          return addLeadingZeros(quarter, 2);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return localize.ordinalNumber(quarter, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return localize.quarter(quarter, {
            width: 'abbreviated',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return localize.quarter(quarter, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return localize.quarter(quarter, {
            width: 'wide',
            context: 'standalone'
          });
      }
    },
    // Month
    M: function (date, token, localize) {
      var month = date.getUTCMonth();

      switch (token) {
        case 'M':
        case 'MM':
          return formatters$3.M(date, token);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return localize.ordinalNumber(month + 1, {
            unit: 'month'
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return localize.month(month, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return localize.month(month, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return localize.month(month, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Stand-alone month
    L: function (date, token, localize) {
      var month = date.getUTCMonth();

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return String(month + 1);
        // 01, 02, ..., 12

        case 'LL':
          return addLeadingZeros(month + 1, 2);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return localize.ordinalNumber(month + 1, {
            unit: 'month'
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return localize.month(month, {
            width: 'abbreviated',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return localize.month(month, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return localize.month(month, {
            width: 'wide',
            context: 'standalone'
          });
      }
    },
    // Local week of year
    w: function (date, token, localize, options) {
      var week = getUTCWeek(date, options);

      if (token === 'wo') {
        return localize.ordinalNumber(week, {
          unit: 'week'
        });
      }

      return addLeadingZeros(week, token.length);
    },
    // ISO week of year
    I: function (date, token, localize) {
      var isoWeek = getUTCISOWeek(date);

      if (token === 'Io') {
        return localize.ordinalNumber(isoWeek, {
          unit: 'week'
        });
      }

      return addLeadingZeros(isoWeek, token.length);
    },
    // Day of the month
    d: function (date, token, localize) {
      if (token === 'do') {
        return localize.ordinalNumber(date.getUTCDate(), {
          unit: 'date'
        });
      }

      return formatters$3.d(date, token);
    },
    // Day of year
    D: function (date, token, localize) {
      var dayOfYear = getUTCDayOfYear(date);

      if (token === 'Do') {
        return localize.ordinalNumber(dayOfYear, {
          unit: 'dayOfYear'
        });
      }

      return addLeadingZeros(dayOfYear, token.length);
    },
    // Day of week
    E: function (date, token, localize) {
      var dayOfWeek = date.getUTCDay();

      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Local day of week
    e: function (date, token, localize, options) {
      var dayOfWeek = date.getUTCDay();
      var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

      switch (token) {
        // Numerical value (Nth day of week with current locale or weekStartsOn)
        case 'e':
          return String(localDayOfWeek);
        // Padded numerical value

        case 'ee':
          return addLeadingZeros(localDayOfWeek, 2);
        // 1st, 2nd, ..., 7th

        case 'eo':
          return localize.ordinalNumber(localDayOfWeek, {
            unit: 'day'
          });

        case 'eee':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Stand-alone local day of week
    c: function (date, token, localize, options) {
      var dayOfWeek = date.getUTCDay();
      var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

      switch (token) {
        // Numerical value (same as in `e`)
        case 'c':
          return String(localDayOfWeek);
        // Padded numerical value

        case 'cc':
          return addLeadingZeros(localDayOfWeek, token.length);
        // 1st, 2nd, ..., 7th

        case 'co':
          return localize.ordinalNumber(localDayOfWeek, {
            unit: 'day'
          });

        case 'ccc':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'standalone'
          });
      }
    },
    // ISO day of week
    i: function (date, token, localize) {
      var dayOfWeek = date.getUTCDay();
      var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

      switch (token) {
        // 2
        case 'i':
          return String(isoDayOfWeek);
        // 02

        case 'ii':
          return addLeadingZeros(isoDayOfWeek, token.length);
        // 2nd

        case 'io':
          return localize.ordinalNumber(isoDayOfWeek, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // T

        case 'iiiii':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'iiiiii':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'formatting'
          });
        // Tuesday

        case 'iiii':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // AM or PM
    a: function (date, token, localize) {
      var hours = date.getUTCHours();
      var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          });

        case 'aaaaa':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // AM, PM, midnight, noon
    b: function (date, token, localize) {
      var hours = date.getUTCHours();
      var dayPeriodEnumValue;

      if (hours === 12) {
        dayPeriodEnumValue = dayPeriodEnum.noon;
      } else if (hours === 0) {
        dayPeriodEnumValue = dayPeriodEnum.midnight;
      } else {
        dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
      }

      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          });

        case 'bbbbb':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function (date, token, localize) {
      var hours = date.getUTCHours();
      var dayPeriodEnumValue;

      if (hours >= 17) {
        dayPeriodEnumValue = dayPeriodEnum.evening;
      } else if (hours >= 12) {
        dayPeriodEnumValue = dayPeriodEnum.afternoon;
      } else if (hours >= 4) {
        dayPeriodEnumValue = dayPeriodEnum.morning;
      } else {
        dayPeriodEnumValue = dayPeriodEnum.night;
      }

      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          });

        case 'BBBBB':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Hour [1-12]
    h: function (date, token, localize) {
      if (token === 'ho') {
        var hours = date.getUTCHours() % 12;
        if (hours === 0) hours = 12;
        return localize.ordinalNumber(hours, {
          unit: 'hour'
        });
      }

      return formatters$3.h(date, token);
    },
    // Hour [0-23]
    H: function (date, token, localize) {
      if (token === 'Ho') {
        return localize.ordinalNumber(date.getUTCHours(), {
          unit: 'hour'
        });
      }

      return formatters$3.H(date, token);
    },
    // Hour [0-11]
    K: function (date, token, localize) {
      var hours = date.getUTCHours() % 12;

      if (token === 'Ko') {
        return localize.ordinalNumber(hours, {
          unit: 'hour'
        });
      }

      return addLeadingZeros(hours, token.length);
    },
    // Hour [1-24]
    k: function (date, token, localize) {
      var hours = date.getUTCHours();
      if (hours === 0) hours = 24;

      if (token === 'ko') {
        return localize.ordinalNumber(hours, {
          unit: 'hour'
        });
      }

      return addLeadingZeros(hours, token.length);
    },
    // Minute
    m: function (date, token, localize) {
      if (token === 'mo') {
        return localize.ordinalNumber(date.getUTCMinutes(), {
          unit: 'minute'
        });
      }

      return formatters$3.m(date, token);
    },
    // Second
    s: function (date, token, localize) {
      if (token === 'so') {
        return localize.ordinalNumber(date.getUTCSeconds(), {
          unit: 'second'
        });
      }

      return formatters$3.s(date, token);
    },
    // Fraction of second
    S: function (date, token) {
      return formatters$3.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function (date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();

      if (timezoneOffset === 0) {
        return 'Z';
      }

      switch (token) {
        // Hours and optional minutes
        case 'X':
          return formatTimezoneWithOptionalMinutes(timezoneOffset);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XX`

        case 'XXXX':
        case 'XX':
          // Hours and minutes without `:` delimiter
          return formatTimezone(timezoneOffset);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XXX`

        case 'XXXXX':
        case 'XXX': // Hours and minutes with `:` delimiter

        default:
          return formatTimezone(timezoneOffset, ':');
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function (date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();

      switch (token) {
        // Hours and optional minutes
        case 'x':
          return formatTimezoneWithOptionalMinutes(timezoneOffset);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xx`

        case 'xxxx':
        case 'xx':
          // Hours and minutes without `:` delimiter
          return formatTimezone(timezoneOffset);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xxx`

        case 'xxxxx':
        case 'xxx': // Hours and minutes with `:` delimiter

        default:
          return formatTimezone(timezoneOffset, ':');
      }
    },
    // Timezone (GMT)
    O: function (date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();

      switch (token) {
        // Short
        case 'O':
        case 'OO':
        case 'OOO':
          return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
        // Long

        case 'OOOO':
        default:
          return 'GMT' + formatTimezone(timezoneOffset, ':');
      }
    },
    // Timezone (specific non-location)
    z: function (date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();

      switch (token) {
        // Short
        case 'z':
        case 'zz':
        case 'zzz':
          return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
        // Long

        case 'zzzz':
        default:
          return 'GMT' + formatTimezone(timezoneOffset, ':');
      }
    },
    // Seconds timestamp
    t: function (date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timestamp = Math.floor(originalDate.getTime() / 1000);
      return addLeadingZeros(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function (date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timestamp = originalDate.getTime();
      return addLeadingZeros(timestamp, token.length);
    }
  };

  function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;

    if (minutes === 0) {
      return sign + String(hours);
    }

    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
  }

  function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
      var sign = offset > 0 ? '-' : '+';
      return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
    }

    return formatTimezone(offset, dirtyDelimiter);
  }

  function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = addLeadingZeros(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
  }

  var formatters$1 = formatters;

  function dateLongFormatter(pattern, formatLong) {
    switch (pattern) {
      case 'P':
        return formatLong.date({
          width: 'short'
        });

      case 'PP':
        return formatLong.date({
          width: 'medium'
        });

      case 'PPP':
        return formatLong.date({
          width: 'long'
        });

      case 'PPPP':
      default:
        return formatLong.date({
          width: 'full'
        });
    }
  }

  function timeLongFormatter(pattern, formatLong) {
    switch (pattern) {
      case 'p':
        return formatLong.time({
          width: 'short'
        });

      case 'pp':
        return formatLong.time({
          width: 'medium'
        });

      case 'ppp':
        return formatLong.time({
          width: 'long'
        });

      case 'pppp':
      default:
        return formatLong.time({
          width: 'full'
        });
    }
  }

  function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];

    if (!timePattern) {
      return dateLongFormatter(pattern, formatLong);
    }

    var dateTimeFormat;

    switch (datePattern) {
      case 'P':
        dateTimeFormat = formatLong.dateTime({
          width: 'short'
        });
        break;

      case 'PP':
        dateTimeFormat = formatLong.dateTime({
          width: 'medium'
        });
        break;

      case 'PPP':
        dateTimeFormat = formatLong.dateTime({
          width: 'long'
        });
        break;

      case 'PPPP':
      default:
        dateTimeFormat = formatLong.dateTime({
          width: 'full'
        });
        break;
    }

    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
  }

  var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
  };
  var longFormatters$1 = longFormatters;

  var protectedDayOfYearTokens = ['D', 'DD'];
  var protectedWeekYearTokens = ['YY', 'YYYY'];
  function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
  }
  function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
  }
  function throwProtectedError(token) {
    if (token === 'YYYY') {
      throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
    } else if (token === 'YY') {
      throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
    } else if (token === 'D') {
      throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
    } else if (token === 'DD') {
      throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
    }
  }

  // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
  //   (one of the certain letters followed by `o`)
  // - (\w)\1* matches any sequences of the same letter
  // - '' matches two quote characters in a row
  // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
  //   except a single quote symbol, which ends the sequence.
  //   Two quote characters do not end the sequence.
  //   If there is no matching single quote
  //   then the sequence will continue until the end of the string.
  // - . matches any single character unmatched by previous parts of the RegExps

  var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
  // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

  var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
  var escapedStringRegExp = /^'([^]*?)'?$/;
  var doubleQuoteRegExp = /''/g;
  var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
  /**
   * @name format
   * @category Common Helpers
   * @summary Format the date.
   *
   * @description
   * Return the formatted date string in the given format. The result may vary by locale.
   *
   * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
   * > See: https://git.io/fxCyr
   *
   * The characters wrapped between two single quotes characters (') are escaped.
   * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
   * (see the last example)
   *
   * Format of the string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   * with a few additions (see note 7 below the table).
   *
   * Accepted patterns:
   * | Unit                            | Pattern | Result examples                   | Notes |
   * |---------------------------------|---------|-----------------------------------|-------|
   * | Era                             | G..GGG  | AD, BC                            |       |
   * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
   * |                                 | GGGGG   | A, B                              |       |
   * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
   * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
   * |                                 | yy      | 44, 01, 00, 17                    | 5     |
   * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
   * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
   * |                                 | yyyyy   | ...                               | 3,5   |
   * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
   * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
   * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
   * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
   * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
   * |                                 | YYYYY   | ...                               | 3,5   |
   * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
   * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
   * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
   * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
   * |                                 | RRRRR   | ...                               | 3,5,7 |
   * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
   * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
   * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
   * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
   * |                                 | uuuuu   | ...                               | 3,5   |
   * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
   * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
   * |                                 | QQ      | 01, 02, 03, 04                    |       |
   * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
   * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
   * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
   * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
   * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
   * |                                 | qq      | 01, 02, 03, 04                    |       |
   * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
   * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
   * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
   * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
   * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
   * |                                 | MM      | 01, 02, ..., 12                   |       |
   * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
   * |                                 | MMMM    | January, February, ..., December  | 2     |
   * |                                 | MMMMM   | J, F, ..., D                      |       |
   * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
   * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
   * |                                 | LL      | 01, 02, ..., 12                   |       |
   * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
   * |                                 | LLLL    | January, February, ..., December  | 2     |
   * |                                 | LLLLL   | J, F, ..., D                      |       |
   * | Local week of year              | w       | 1, 2, ..., 53                     |       |
   * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
   * |                                 | ww      | 01, 02, ..., 53                   |       |
   * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
   * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
   * |                                 | II      | 01, 02, ..., 53                   | 7     |
   * | Day of month                    | d       | 1, 2, ..., 31                     |       |
   * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
   * |                                 | dd      | 01, 02, ..., 31                   |       |
   * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
   * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
   * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
   * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
   * |                                 | DDDD    | ...                               | 3     |
   * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
   * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
   * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
   * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
   * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
   * |                                 | ii      | 01, 02, ..., 07                   | 7     |
   * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
   * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
   * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
   * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
   * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
   * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
   * |                                 | ee      | 02, 03, ..., 01                   |       |
   * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
   * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
   * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
   * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
   * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
   * |                                 | cc      | 02, 03, ..., 01                   |       |
   * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
   * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
   * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
   * | AM, PM                          | a..aaa  | AM, PM                            |       |
   * |                                 | aaaa    | a.m., p.m.                        | 2     |
   * |                                 | aaaaa   | a, p                              |       |
   * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
   * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
   * |                                 | bbbbb   | a, p, n, mi                       |       |
   * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
   * |                                 | BBBB    | at night, in the morning, ...     | 2     |
   * |                                 | BBBBB   | at night, in the morning, ...     |       |
   * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
   * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
   * |                                 | hh      | 01, 02, ..., 11, 12               |       |
   * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
   * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
   * |                                 | HH      | 00, 01, 02, ..., 23               |       |
   * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
   * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
   * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
   * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
   * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
   * |                                 | kk      | 24, 01, 02, ..., 23               |       |
   * | Minute                          | m       | 0, 1, ..., 59                     |       |
   * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
   * |                                 | mm      | 00, 01, ..., 59                   |       |
   * | Second                          | s       | 0, 1, ..., 59                     |       |
   * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
   * |                                 | ss      | 00, 01, ..., 59                   |       |
   * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
   * |                                 | SS      | 00, 01, ..., 99                   |       |
   * |                                 | SSS     | 000, 0001, ..., 999               |       |
   * |                                 | SSSS    | ...                               | 3     |
   * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
   * |                                 | XX      | -0800, +0530, Z                   |       |
   * |                                 | XXX     | -08:00, +05:30, Z                 |       |
   * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
   * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
   * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
   * |                                 | xx      | -0800, +0530, +0000               |       |
   * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
   * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
   * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
   * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
   * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
   * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
   * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
   * | Seconds timestamp               | t       | 512969520                         | 7     |
   * |                                 | tt      | ...                               | 3,7   |
   * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
   * |                                 | TT      | ...                               | 3,7   |
   * | Long localized date             | P       | 05/29/1453                        | 7     |
   * |                                 | PP      | May 29, 1453                      | 7     |
   * |                                 | PPP     | May 29th, 1453                    | 7     |
   * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
   * | Long localized time             | p       | 12:00 AM                          | 7     |
   * |                                 | pp      | 12:00:00 AM                       | 7     |
   * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
   * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
   * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
   * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
   * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
   * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
   * Notes:
   * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
   *    are the same as "stand-alone" units, but are different in some languages.
   *    "Formatting" units are declined according to the rules of the language
   *    in the context of a date. "Stand-alone" units are always nominative singular:
   *
   *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
   *
   *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
   *
   * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
   *    the single quote characters (see below).
   *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
   *    the output will be the same as default pattern for this unit, usually
   *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
   *    are marked with "2" in the last column of the table.
   *
   *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
   *
   * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
   *    The output will be padded with zeros to match the length of the pattern.
   *
   *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
   *
   * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
   *    These tokens represent the shortest form of the quarter.
   *
   * 5. The main difference between `y` and `u` patterns are B.C. years:
   *
   *    | Year | `y` | `u` |
   *    |------|-----|-----|
   *    | AC 1 |   1 |   1 |
   *    | BC 1 |   1 |   0 |
   *    | BC 2 |   2 |  -1 |
   *
   *    Also `yy` always returns the last two digits of a year,
   *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
   *
   *    | Year | `yy` | `uu` |
   *    |------|------|------|
   *    | 1    |   01 |   01 |
   *    | 14   |   14 |   14 |
   *    | 376  |   76 |  376 |
   *    | 1453 |   53 | 1453 |
   *
   *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
   *    except local week-numbering years are dependent on `options.weekStartsOn`
   *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
   *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
   *
   * 6. Specific non-location timezones are currently unavailable in `date-fns`,
   *    so right now these tokens fall back to GMT timezones.
   *
   * 7. These patterns are not in the Unicode Technical Standard #35:
   *    - `i`: ISO day of week
   *    - `I`: ISO week of year
   *    - `R`: ISO week-numbering year
   *    - `t`: seconds timestamp
   *    - `T`: milliseconds timestamp
   *    - `o`: ordinal number modifier
   *    - `P`: long localized date
   *    - `p`: long localized time
   *
   * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
   *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
   *
   * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
   *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * - The second argument is now required for the sake of explicitness.
   *
   *   ```javascript
   *   // Before v2.0.0
   *   format(new Date(2016, 0, 1))
   *
   *   // v2.0.0 onward
   *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
   *   ```
   *
   * - New format string API for `format` function
   *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
   *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
   *
   * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
   *
   * @param {Date|Number} date - the original date
   * @param {String} format - the string of tokens
   * @param {Object} [options] - an object with options.
   * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
   * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
   * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
   * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
   *   see: https://git.io/fxCyr
   * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
   *   see: https://git.io/fxCyr
   * @returns {String} the formatted date string
   * @throws {TypeError} 2 arguments required
   * @throws {RangeError} `date` must not be Invalid Date
   * @throws {RangeError} `options.locale` must contain `localize` property
   * @throws {RangeError} `options.locale` must contain `formatLong` property
   * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
   * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
   * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
   * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
   * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
   * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
   * @throws {RangeError} format string contains an unescaped latin alphabet character
   *
   * @example
   * // Represent 11 February 2014 in middle-endian format:
   * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
   * //=> '02/11/2014'
   *
   * @example
   * // Represent 2 July 2014 in Esperanto:
   * import { eoLocale } from 'date-fns/locale/eo'
   * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
   *   locale: eoLocale
   * })
   * //=> '2-a de julio 2014'
   *
   * @example
   * // Escape string by single quote characters:
   * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
   * //=> "3 o'clock"
   */

  function format$1(dirtyDate, dirtyFormatStr, dirtyOptions) {
    requiredArgs(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || defaultLocale;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    }

    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }

    if (!locale.localize) {
      throw new RangeError('locale must contain localize property');
    }

    if (!locale.formatLong) {
      throw new RangeError('locale must contain formatLong property');
    }

    var originalDate = toDate(dirtyDate);

    if (!isValid(originalDate)) {
      throw new RangeError('Invalid time value');
    } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


    var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
    var utcDate = subMilliseconds(originalDate, timezoneOffset);
    var formatterOptions = {
      firstWeekContainsDate: firstWeekContainsDate,
      weekStartsOn: weekStartsOn,
      locale: locale,
      _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
      var firstCharacter = substring[0];

      if (firstCharacter === 'p' || firstCharacter === 'P') {
        var longFormatter = longFormatters$1[firstCharacter];
        return longFormatter(substring, locale.formatLong, formatterOptions);
      }

      return substring;
    }).join('').match(formattingTokensRegExp).map(function (substring) {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return "'";
      }

      var firstCharacter = substring[0];

      if (firstCharacter === "'") {
        return cleanEscapedString(substring);
      }

      var formatter = formatters$1[firstCharacter];

      if (formatter) {
        if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
          throwProtectedError(substring);
        }

        if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
          throwProtectedError(substring);
        }

        return formatter(utcDate, substring, locale.localize, formatterOptions);
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      }

      return substring;
    }).join('');
    return result;
  }

  function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
  }

  var MILLISECONDS_IN_HOUR = 3600000;
  var MILLISECONDS_IN_MINUTE = 60000;
  var DEFAULT_ADDITIONAL_DIGITS = 2;
  var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
  };
  var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
  var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
  var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
  /**
   * @name parseISO
   * @category Common Helpers
   * @summary Parse ISO string
   *
   * @description
   * Parse the given string in ISO 8601 format and return an instance of Date.
   *
   * Function accepts complete ISO 8601 formats as well as partial implementations.
   * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
   *
   * If the argument isn't a string, the function cannot parse the string or
   * the values are invalid, it returns Invalid Date.
   *
   * ### v2.0.0 breaking changes:
   *
   * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
   *
   * - The previous `parse` implementation was renamed to `parseISO`.
   *
   *   ```javascript
   *   // Before v2.0.0
   *   parse('2016-01-01')
   *
   *   // v2.0.0 onward
   *   parseISO('2016-01-01')
   *   ```
   *
   * - `parseISO` now validates separate date and time values in ISO-8601 strings
   *   and returns `Invalid Date` if the date is invalid.
   *
   *   ```javascript
   *   parseISO('2018-13-32')
   *   //=> Invalid Date
   *   ```
   *
   * - `parseISO` now doesn't fall back to `new Date` constructor
   *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
   *
   * @param {String} argument - the value to convert
   * @param {Object} [options] - an object with options.
   * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
   * @returns {Date} the parsed date in the local time zone
   * @throws {TypeError} 1 argument required
   * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
   *
   * @example
   * // Convert string '2014-02-11T11:30:30' to date:
   * var result = parseISO('2014-02-11T11:30:30')
   * //=> Tue Feb 11 2014 11:30:30
   *
   * @example
   * // Convert string '+02014101' to date,
   * // if the additional number of digits in the extended year format is 1:
   * var result = parseISO('+02014101', { additionalDigits: 1 })
   * //=> Fri Apr 11 2014 00:00:00
   */

  function parseISO(argument, dirtyOptions) {
    requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);

    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
      throw new RangeError('additionalDigits must be 0, 1 or 2');
    }

    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
      return new Date(NaN);
    }

    var dateStrings = splitDateString(argument);
    var date;

    if (dateStrings.date) {
      var parseYearResult = parseYear(dateStrings.date, additionalDigits);
      date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }

    if (isNaN(date) || !date) {
      return new Date(NaN);
    }

    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time) || time === null) {
        return new Date(NaN);
      }
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone);

      if (isNaN(offset)) {
        return new Date(NaN);
      }
    } else {
      var fullTime = timestamp + time;
      var fullTimeDate = new Date(fullTime);
      offset = getTimezoneOffsetInMilliseconds(fullTimeDate); // Adjust time when it's coming from DST

      var fullTimeDateDiffDay = new Date(fullTime);

      if (offset > 0) {
        fullTimeDateDiffDay.setDate(fullTimeDate.getDate() + 1);
      } else {
        fullTimeDateDiffDay.setDate(fullTimeDate.getDate() - 1);
      }

      var offsetDiff = getTimezoneOffsetInMilliseconds(fullTimeDateDiffDay) - offset;

      if (offsetDiff > 0) {
        offset += offsetDiff;
      }
    }

    return new Date(timestamp + time + offset);
  }

  function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;

    if (/:/.test(array[0])) {
      dateStrings.date = null;
      timeString = array[0];
    } else {
      dateStrings.date = array[0];
      timeString = array[1];

      if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
        dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
        timeString = dateString.substr(dateStrings.date.length, dateString.length);
      }
    }

    if (timeString) {
      var token = patterns.timezone.exec(timeString);

      if (token) {
        dateStrings.time = timeString.replace(token[1], '');
        dateStrings.timezone = token[1];
      } else {
        dateStrings.time = timeString;
      }
    }

    return dateStrings;
  }

  function parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex); // Invalid ISO-formatted year

    if (!captures) return {
      year: null
    };
    var year = captures[1] && parseInt(captures[1]);
    var century = captures[2] && parseInt(captures[2]);
    return {
      year: century == null ? year : century * 100,
      restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
  }

  function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

    if (!captures) return null;
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;

    if (isWeekDate) {
      if (!validateWeekDate(year, week, dayOfWeek)) {
        return new Date(NaN);
      }

      return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
      var date = new Date(0);

      if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
        return new Date(NaN);
      }

      date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
      return date;
    }
  }

  function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
  }

  function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return null; // Invalid ISO-formatted time

    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);

    if (!validateTime(hours, minutes, seconds)) {
      return NaN;
    }

    return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
  }

  function parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
  }

  function parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;

    if (!validateTimezone(hours, minutes)) {
      return NaN;
    }

    return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
  }

  function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
  } // Validation functions
  // February is null to handle the leap year (using ||)


  var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100;
  }

  function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
  }

  function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
  }

  function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
  }

  function validateTime(hours, minutes, seconds) {
    if (hours === 24) {
      return minutes === 0 && seconds === 0;
    }

    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
  }

  function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
  }

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */

  var isArray$3 = Array.isArray;

  var isArray_1 = isArray$3;

  /** Detect free variable `global` from Node.js. */

  var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  var _freeGlobal = freeGlobal$1;

  var freeGlobal = _freeGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root$3 = freeGlobal || freeSelf || Function('return this')();

  var _root = root$3;

  var root$2 = _root;

  /** Built-in value references. */
  var Symbol$3 = root$2.Symbol;

  var _Symbol = Symbol$3;

  var Symbol$2 = _Symbol;

  /** Used for built-in method references. */
  var objectProto$4 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString$1 = objectProto$4.toString;

  /** Built-in value references. */
  var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag$1(value) {
    var isOwn = hasOwnProperty$3.call(value, symToStringTag$1),
        tag = value[symToStringTag$1];

    try {
      value[symToStringTag$1] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString$1.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag$1] = tag;
      } else {
        delete value[symToStringTag$1];
      }
    }
    return result;
  }

  var _getRawTag = getRawTag$1;

  /** Used for built-in method references. */

  var objectProto$3 = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto$3.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString$1(value) {
    return nativeObjectToString.call(value);
  }

  var _objectToString = objectToString$1;

  var Symbol$1 = _Symbol,
      getRawTag = _getRawTag,
      objectToString = _objectToString;

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag$2(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag && symToStringTag in Object(value))
      ? getRawTag(value)
      : objectToString(value);
  }

  var _baseGetTag = baseGetTag$2;

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */

  function isObjectLike$1(value) {
    return value != null && typeof value == 'object';
  }

  var isObjectLike_1 = isObjectLike$1;

  var baseGetTag$1 = _baseGetTag,
      isObjectLike = isObjectLike_1;

  /** `Object#toString` result references. */
  var symbolTag = '[object Symbol]';

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol$3(value) {
    return typeof value == 'symbol' ||
      (isObjectLike(value) && baseGetTag$1(value) == symbolTag);
  }

  var isSymbol_1 = isSymbol$3;

  var isArray$2 = isArray_1,
      isSymbol$2 = isSymbol_1;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/;

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey$1(value, object) {
    if (isArray$2(value)) {
      return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
        value == null || isSymbol$2(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object));
  }

  var _isKey = isKey$1;

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */

  function isObject$2(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }

  var isObject_1 = isObject$2;

  var baseGetTag = _baseGetTag,
      isObject$1 = isObject_1;

  /** `Object#toString` result references. */
  var asyncTag = '[object AsyncFunction]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction$1(value) {
    if (!isObject$1(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  var isFunction_1 = isFunction$1;

  var root$1 = _root;

  /** Used to detect overreaching core-js shims. */
  var coreJsData$1 = root$1['__core-js_shared__'];

  var _coreJsData = coreJsData$1;

  var coreJsData = _coreJsData;

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = (function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
  }());

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked$1(func) {
    return !!maskSrcKey && (maskSrcKey in func);
  }

  var _isMasked = isMasked$1;

  /** Used for built-in method references. */

  var funcProto$1 = Function.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString$1 = funcProto$1.toString;

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource$1(func) {
    if (func != null) {
      try {
        return funcToString$1.call(func);
      } catch (e) {}
      try {
        return (func + '');
      } catch (e) {}
    }
    return '';
  }

  var _toSource = toSource$1;

  var isFunction = isFunction_1,
      isMasked = _isMasked,
      isObject = isObject_1,
      toSource = _toSource;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used for built-in method references. */
  var funcProto = Function.prototype,
      objectProto$2 = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' +
    funcToString.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  );

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative$1(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  var _baseIsNative = baseIsNative$1;

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */

  function getValue$1(object, key) {
    return object == null ? undefined : object[key];
  }

  var _getValue = getValue$1;

  var baseIsNative = _baseIsNative,
      getValue = _getValue;

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative$2(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  var _getNative = getNative$2;

  var getNative$1 = _getNative;

  /* Built-in method references that are verified to be native. */
  var nativeCreate$4 = getNative$1(Object, 'create');

  var _nativeCreate = nativeCreate$4;

  var nativeCreate$3 = _nativeCreate;

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear$1() {
    this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
    this.size = 0;
  }

  var _hashClear = hashClear$1;

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */

  function hashDelete$1(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  var _hashDelete = hashDelete$1;

  var nativeCreate$2 = _nativeCreate;

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

  /** Used for built-in method references. */
  var objectProto$1 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet$1(key) {
    var data = this.__data__;
    if (nativeCreate$2) {
      var result = data[key];
      return result === HASH_UNDEFINED$1 ? undefined : result;
    }
    return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
  }

  var _hashGet = hashGet$1;

  var nativeCreate$1 = _nativeCreate;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas$1(key) {
    var data = this.__data__;
    return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
  }

  var _hashHas = hashHas$1;

  var nativeCreate = _nativeCreate;

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet$1(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
    return this;
  }

  var _hashSet = hashSet$1;

  var hashClear = _hashClear,
      hashDelete = _hashDelete,
      hashGet = _hashGet,
      hashHas = _hashHas,
      hashSet = _hashSet;

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash$1(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `Hash`.
  Hash$1.prototype.clear = hashClear;
  Hash$1.prototype['delete'] = hashDelete;
  Hash$1.prototype.get = hashGet;
  Hash$1.prototype.has = hashHas;
  Hash$1.prototype.set = hashSet;

  var _Hash = Hash$1;

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */

  function listCacheClear$1() {
    this.__data__ = [];
    this.size = 0;
  }

  var _listCacheClear = listCacheClear$1;

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */

  function eq$1(value, other) {
    return value === other || (value !== value && other !== other);
  }

  var eq_1 = eq$1;

  var eq = eq_1;

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf$4(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  var _assocIndexOf = assocIndexOf$4;

  var assocIndexOf$3 = _assocIndexOf;

  /** Used for built-in method references. */
  var arrayProto = Array.prototype;

  /** Built-in value references. */
  var splice = arrayProto.splice;

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete$1(key) {
    var data = this.__data__,
        index = assocIndexOf$3(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }

  var _listCacheDelete = listCacheDelete$1;

  var assocIndexOf$2 = _assocIndexOf;

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet$1(key) {
    var data = this.__data__,
        index = assocIndexOf$2(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  var _listCacheGet = listCacheGet$1;

  var assocIndexOf$1 = _assocIndexOf;

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas$1(key) {
    return assocIndexOf$1(this.__data__, key) > -1;
  }

  var _listCacheHas = listCacheHas$1;

  var assocIndexOf = _assocIndexOf;

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet$1(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  var _listCacheSet = listCacheSet$1;

  var listCacheClear = _listCacheClear,
      listCacheDelete = _listCacheDelete,
      listCacheGet = _listCacheGet,
      listCacheHas = _listCacheHas,
      listCacheSet = _listCacheSet;

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache$1(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `ListCache`.
  ListCache$1.prototype.clear = listCacheClear;
  ListCache$1.prototype['delete'] = listCacheDelete;
  ListCache$1.prototype.get = listCacheGet;
  ListCache$1.prototype.has = listCacheHas;
  ListCache$1.prototype.set = listCacheSet;

  var _ListCache = ListCache$1;

  var getNative = _getNative,
      root = _root;

  /* Built-in method references that are verified to be native. */
  var Map$1 = getNative(root, 'Map');

  var _Map = Map$1;

  var Hash = _Hash,
      ListCache = _ListCache,
      Map = _Map;

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear$1() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash,
      'map': new (Map || ListCache),
      'string': new Hash
    };
  }

  var _mapCacheClear = mapCacheClear$1;

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */

  function isKeyable$1(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
      ? (value !== '__proto__')
      : (value === null);
  }

  var _isKeyable = isKeyable$1;

  var isKeyable = _isKeyable;

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData$4(map, key) {
    var data = map.__data__;
    return isKeyable(key)
      ? data[typeof key == 'string' ? 'string' : 'hash']
      : data.map;
  }

  var _getMapData = getMapData$4;

  var getMapData$3 = _getMapData;

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete$1(key) {
    var result = getMapData$3(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  var _mapCacheDelete = mapCacheDelete$1;

  var getMapData$2 = _getMapData;

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet$1(key) {
    return getMapData$2(this, key).get(key);
  }

  var _mapCacheGet = mapCacheGet$1;

  var getMapData$1 = _getMapData;

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas$1(key) {
    return getMapData$1(this, key).has(key);
  }

  var _mapCacheHas = mapCacheHas$1;

  var getMapData = _getMapData;

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet$1(key, value) {
    var data = getMapData(this, key),
        size = data.size;

    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  var _mapCacheSet = mapCacheSet$1;

  var mapCacheClear = _mapCacheClear,
      mapCacheDelete = _mapCacheDelete,
      mapCacheGet = _mapCacheGet,
      mapCacheHas = _mapCacheHas,
      mapCacheSet = _mapCacheSet;

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache$1(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `MapCache`.
  MapCache$1.prototype.clear = mapCacheClear;
  MapCache$1.prototype['delete'] = mapCacheDelete;
  MapCache$1.prototype.get = mapCacheGet;
  MapCache$1.prototype.has = mapCacheHas;
  MapCache$1.prototype.set = mapCacheSet;

  var _MapCache = MapCache$1;

  var MapCache = _MapCache;

  /** Error message constants. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `clear`, `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize$1(func, resolver) {
    if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };
    memoized.cache = new (memoize$1.Cache || MapCache);
    return memoized;
  }

  // Expose `MapCache`.
  memoize$1.Cache = MapCache;

  var memoize_1 = memoize$1;

  var memoize = memoize_1;

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /**
   * A specialized version of `_.memoize` which clears the memoized function's
   * cache when it exceeds `MAX_MEMOIZE_SIZE`.
   *
   * @private
   * @param {Function} func The function to have its output memoized.
   * @returns {Function} Returns the new memoized function.
   */
  function memoizeCapped$1(func) {
    var result = memoize(func, function(key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });

    var cache = result.cache;
    return result;
  }

  var _memoizeCapped = memoizeCapped$1;

  var memoizeCapped = _memoizeCapped;

  /** Used to match property names within property paths. */
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath$1 = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
    string.replace(rePropName, function(match, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
    });
    return result;
  });

  var _stringToPath = stringToPath$1;

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */

  function arrayMap$1(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  var _arrayMap = arrayMap$1;

  var Symbol = _Symbol,
      arrayMap = _arrayMap,
      isArray$1 = isArray_1,
      isSymbol$1 = isSymbol_1;

  /** Used as references for various `Number` constants. */
  var INFINITY$1 = 1 / 0;

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString$1(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isArray$1(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString$1) + '';
    }
    if (isSymbol$1(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
  }

  var _baseToString = baseToString$1;

  var baseToString = _baseToString;

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString$1(value) {
    return value == null ? '' : baseToString(value);
  }

  var toString_1 = toString$1;

  var isArray = isArray_1,
      isKey = _isKey,
      stringToPath = _stringToPath,
      toString = toString_1;

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {Object} [object] The object to query keys on.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath$1(value, object) {
    if (isArray(value)) {
      return value;
    }
    return isKey(value, object) ? [value] : stringToPath(toString(value));
  }

  var _castPath = castPath$1;

  var isSymbol = isSymbol_1;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey$1(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
  }

  var _toKey = toKey$1;

  var castPath = _castPath,
      toKey = _toKey;

  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */
  function baseGet$1(object, path) {
    path = castPath(path, object);

    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }
    return (index && index == length) ? object : undefined;
  }

  var _baseGet = baseGet$1;

  var baseGet = _baseGet;

  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */
  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }

  var get_1 = get;

  var _get = /*@__PURE__*/getDefaultExportFromCjs(get_1);

  const DEFAULT_BASE_APP_URL = "https://app.readcube.com";
  const DEFAULT_BASE_WEB_URL = "https://www.readcube.com";
  const asRis = ({ item, newLine, mapping, baseAppUrl, baseWebUrl }) => {
      var _a;
      baseAppUrl = baseAppUrl !== null && baseAppUrl !== void 0 ? baseAppUrl : DEFAULT_BASE_APP_URL;
      baseWebUrl = baseWebUrl !== null && baseWebUrl !== void 0 ? baseWebUrl : DEFAULT_BASE_WEB_URL;
      let out = getMetadata$1(item, mapping || meta);
      out.push(["UR", baseAppUrl + `/library/${item.collection_id}/item/${item.id}`]);
      if ((_a = item.files) === null || _a === void 0 ? void 0 : _a.length)
          out.push(["PF", baseWebUrl + `/library/${item.collection_id}:${item.id}`]);
      out = removeEmpty(out);
      addEndRecord(out);
      const tyIndex = out.findIndex(pair => pair[0] === "TY");
      if (tyIndex !== -1) {
          const [ty] = out.splice(tyIndex, 1);
          out.unshift(ty);
      }
      return format$2(out, newLine);
  };
  const addEndRecord = (out) => out.push(["ER", ""]);
  const removeEmpty = (out) => out.filter((entry) => entry[1] && entry[1] !== "");
  const getMetadata$1 = (item, mapping) => {
      var _a, _b;
      const defaultTypeName = defaultTypeNameFromMapping(mapping);
      const type = item.custom_type
          || item.item_type
          || defaultTypeName;
      console.log({ type });
      let typeFields = (_a = mapping.types[type]) === null || _a === void 0 ? void 0 : _a.fields;
      if (!typeFields)
          typeFields = (_b = mapping.types[defaultTypeName]) === null || _b === void 0 ? void 0 : _b.fields;
      if (!typeFields)
          throw new Error("I can't figure out the type fields for type:" + type);
      let out = typeFields
          .map((field) => mapping.field_defs[field])
          .filter((fieldDef) => fieldDef && fieldDef.ris)
          .reduce((risFields, fieldDef) => {
          const { ris } = fieldDef;
          const value = _get(item, fieldDef.readcube || `custom_metadata.${fieldDef.custom_metadata}`);
          if (ris.includes(",")) {
              const risAliases = ris.split(",");
              risAliases.forEach((r) => risFields.push([r, value]));
          }
          else if (ris === "AU" && value) {
              risFields = [...risFields, ...value.map((v) => [ris, formatAuthor(v)])];
          }
          else if (ris === "KW" && value) {
              risFields = [...risFields, ...value.map((v) => [ris, v])];
          }
          else {
              risFields.push([ris, value]);
          }
          return risFields;
      }, []);
      out.unshift(["TY", mapping.types[type] && mapping.types[type].ris_type]);
      if (!out.find(entry => entry[0] === "AU"))
          out = [...authors(item), ...out];
      const daEntry = out.find(entry => entry[0] === "DA");
      if (daEntry) {
          const date = parseISO(daEntry[1]);
          if (isValid(date))
              daEntry[1] = format$1(date, "yyyy/MM/dd");
      }
      const yearEntry = out.find(entry => entry[0] === "PY");
      if (item.article.year && (!yearEntry || !yearEntry[1]))
          out.push(["PY", item.article.year]);
      onFile(item, p => { out.push(["L1", p]); });
      return out;
  };

  const propMap = {
      year: (item) => item.article.year || "",
      month: (item) => item.article.month || "",
      rating: (item) => item.user_data && item.user_data.rating,
      keywords: (item) => item.user_data
          && item.user_data.tags
          && item.user_data.tags.join(),
  };

  const format = (out, item, meta, nl) => {
      var _a, _b;
      let frmt = "@" + getBibType(item, meta) + "{";
      frmt += ((_a = item === null || item === void 0 ? void 0 : item.user_data) === null || _a === void 0 ? void 0 : _a.citekey) || ((_b = item === null || item === void 0 ? void 0 : item.ext_ids) === null || _b === void 0 ? void 0 : _b.doi);
      frmt += `, ${nl}`;
      frmt += Object
          .entries(out)
          .map(entry => {
          const [key, value] = entry;
          const escVal = ["local-url", "author"].includes(key) ? value : bibEsc(value);
          return ["title", "abstract"].includes(key)
              ? `${key} = {{${escVal}}}`
              : `${key} = {${escVal}}`;
      })
          .join(", " + nl);
      frmt += `${nl}}`;
      return frmt;
  };
  function getBibType(item, meta) {
      if (!item.custom_metadata || !item.custom_metadata.type)
          return "article";
      const typeName = item.custom_metadata.type;
      const typeDef = meta.types[typeName];
      if (!typeDef)
          return "article";
      return typeDef.bib_type || "article";
  }
  function bibEsc(value) {
      return typeof value !== "string"
          ? value
          : value
              .replace('\n', ' ')
              .replace(/~/g, "\\textasciitilde")
              .replace(/\\/g, "\\textbackslash")
              .replace(/\^/g, "\\textasciicircum")
              .replace(/[&%$#_{}]/g, "\\$&");
  }
  function bibAuthorFormat(val) {
      return Array.isArray(val)
          ? val
              .map(formatAuthor)
              .map((a) => (a === null || a === void 0 ? void 0 : a.split(" ").includes("and")) ? "{" + bibEsc(a) + "}" : bibEsc(a))
              .join(" and ")
          : [];
  }

  const asBib = ({ item, newLine, mapping }) => {
      const nl = getNewLine(newLine);
      let out = {};
      addReadcubeItemData(out, item);
      out = getMetadata(out, item, mapping || meta);
      out = removeEmpty$1(out);
      return format(out, item, mapping || meta, nl);
  };
  const addReadcubeItemData = (out, item) => {
      for (const [name, generator] of Object.entries(propMap)) {
          if (!out[name])
              out[name] = generator(item);
      }
  };
  const getMetadata = (out, item, mapping) => {
      var _a, _b;
      const defaultTypeName = defaultTypeNameFromMapping(mapping);
      const type = item.custom_type
          || item.item_type
          || defaultTypeName;
      let typeFields = (_a = mapping.types[type]) === null || _a === void 0 ? void 0 : _a.fields;
      if (!typeFields)
          typeFields = (_b = mapping.types[defaultTypeName]) === null || _b === void 0 ? void 0 : _b.fields;
      const custom = typeFields
          .map((field) => {
          const fieldName = field.name || field;
          const fieldDef = mapping.field_defs[fieldName];
          return [fieldName, fieldDef];
      })
          .filter((fieldWithDef) => fieldWithDef[1] && fieldWithDef[1].bib)
          .reduce((acc, fieldWithDef) => {
          var _a;
          const [field, fieldDef] = fieldWithDef;
          const value = fieldDef.readcube
              ? _get(item, fieldDef.readcube)
              : item.custom_metadata && item.custom_metadata[fieldDef.custom_metadata];
          const bib = ((_a = fieldDef.bib) === null || _a === void 0 ? void 0 : _a.includes(','))
              ? fieldDef.bib.split(',')[0]
              : fieldDef.bib;
          acc[bib] = transform(bib, value);
          return acc;
      }, {});
      if (item.custom_metadata && (item.custom_metadata.published || item.custom_metadata.date)) {
          const { year, month } = getYearMonth(item.custom_metadata.published || item.custom_metadata.date);
          if (year)
              custom.year = year;
          if (month)
              custom.month = month;
      }
      if (out.year != null)
          delete custom.year;
      onFile(item, path => custom["local-url"] = path);
      return Object.assign(Object.assign({}, removeEmpty$1(out)), removeEmpty$1(custom));
      function transform(field, value) {
          const transforms = {
              author: bibAuthorFormat,
              editor: (v) => v && bibAuthorFormat((v + "").split(",")),
              pages: (v) => ((v || "") + "").replace("-", "--"),
          };
          return transforms[field]
              ? transforms[field](value)
              : value;
      }
  };

  exports.asBib = asBib;
  exports.asRis = asRis;

}));
